import React from "react";
import contextProvider from "../../contextProvider";
import { LinkContainer } from "react-router-bootstrap";
import {
  Row,
  Col,
  ButtonGroup,
  Badge,
  ListGroup,
  Input,
  ListGroupItem,
  FormFeedback,
  FormText,
  CustomInput,
} from "reactstrap";
import { ClipLoader } from "react-spinners";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../_L0_components/Widgets/_LoadingKit";
import PieChart from "../Elements/PieChart";
import NotesEditor from "../Elements/NotesEditor";
import StepTimingGraph from "../Elements/StepTimingGraph";
import ErrorGraph from "../Elements/ErrorGraph";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOModal from "../../_L1_components/Elements/ReactOModal";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import ReactOForm from "../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../_L1_components/Elements/ReactOFormInput";
import ReactOTable from "../../_L1_components/Elements/ReactOTable";
import Section from "../../_L1_components/Layout/Section";
import Panel from "../../_L1_components/Layout/Panel";
import ErrorTimingGraph from "../Elements/ErrorTimingGraph";

class ProbeMeasureExplorer extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      loadingErrorGraph: false,
      data: {},
      measure_graph: {},
      step_graph: null,
      timingView: false,
      _activePopup: null,
      customYref: undefined,
      defaultYref: undefined,
      invalidYref: false,
      inputFieldValue: undefined,
      _popupData: {},
      showInputTime: false,
      range: undefined,
      switchError: false,
      isCustom: false,
      arrayOfErrors: [],
    };
    super(props, initState);
    this.dateRangePicker = React.createRef();
    this._errorList = null;
    this.phaseColors = {
      measures: [
        "#0774F2",
        "#0976F2",
        "#0C78F2",
        "#0F7BF2",
        "#127DF2",
        "#1580F3",
        "#1882F3",
        "#1B84F3",
        "#1E87F3",
        "#2189F4",
        "#248CF4",
        "#278EF4",
        "#2A91F4",
        "#2D93F4",
        "#3095F5",
        "#3398F5",
        "#359AF5",
        "#389DF5",
        "#3B9FF6",
        "#3EA1F6",
        "#41A4F6",
        "#44A6F6",
        "#47A9F6",
        "#4AABF7",
        "#4DAEF7",
        "#50B0F7",
        "#53B2F7",
        "#56B5F8",
        "#59B7F8",
        "#5CBAF8",
        "#5FBCF8",
        "#62BFF9",
      ],
      errors: [
        "#A42818",
        "#A62B17",
        "#A92E16",
        "#AC3116",
        "#AF3415",
        "#B23715",
        "#B53B14",
        "#B83E14",
        "#BA4113",
        "#BD4413",
        "#C04712",
        "#C34B12",
        "#C64E11",
        "#C95111",
        "#CC5410",
        "#CF5710",
        "#D15B0F",
        "#D45E0F",
        "#D7610E",
        "#DA640E",
        "#DD670D",
        "#E06B0D",
        "#E36E0C",
        "#E6710C",
        "#E8740B",
        "#EB770B",
        "#EE7B0A",
        "#F17E0A",
        "#F48109",
        "#F78409",
        "#FA8708",
        "#FD8B08",
      ],
    };

    this.apiStore = null;
  }

  delayForm(time, yref) {
    if (time == this.globalTime && !this.state.invalidYref) {
      if (this._AUTO_RELOAD_TIMEOUT) {
        clearTimeout(this._AUTO_RELOAD_TIMEOUT);
      }
      if (this.checkStartDateLoop) {
        clearTimeout(this.checkStartDateLoop);
      }
      this.setState({ customYref: yref, startSpin: false });
      // this._view_form.submit();
      let data = this.getAppContext()
        .getLocalStorageService()
        .get("measure_graph_view");
      this.loadMeasureGraph(data);
    }
  }

  delayFormInput(time, string) {
    if (time == this.globalTime && !this.state.invalidCustomRange) {
      if (this._AUTO_RELOAD_TIMEOUT) {
        clearTimeout(this._AUTO_RELOAD_TIMEOUT);
      }
      if (this.checkStartDateLoop) {
        clearTimeout(this.checkStartDateLoop);
      }
      this.setState({ startSpinForInput: false });
      this.submitCustomRange();
    }
  }

  submitCustomRange() {
    // let string = this.state.range.replace(/\s+/g, "");
    // console.log("this.state.range", this.state.range);
    let start = this.state.range.split("-")[0];
    let end = this.state.range.split("-")[1];

    if (
      this.getAppContext().momentjs(start, "L LT").isValid() &&
      this.getAppContext().momentjs(end, "L LT").isValid()
    ) {
      let start_customTime = this.getAppContext()
        .momentjs(start, "L LT")
        .unix();
      let end_customTime = this.getAppContext().momentjs(end, "L LT").unix();

      try {
        if (
          start_customTime &&
          end_customTime &&
          end_customTime > start_customTime
        ) {
          this._view_form.handleFormChange("is_preset", "no");
          this._view_form.handleFormChange("view_preset", "no");
          this._view_form.handleFormChange("offset", false);
          this._view_form.handleFormChange("stime", start_customTime);
          this._view_form.handleFormChange("etime", end_customTime);
          this._view_form.handleFormChange("snapStime", "");
          this._view_form.handleFormChange("snapEtime", "");
          this._view_form.submit();
          this.setState({ showInputTime: false, range: undefined });
        } else {
          throw new Error("Data interval not valid");
        }
      } catch (err) {
        console.error(err.message);
        this.setState({
          invalidCustomRange: true,
          invalidCustomRangeMsg: "Data interval not valid",
        });
      }
    } else {
      this.setState({
        invalidCustomRange: true,
        invalidCustomRangeMsg:
          "Sample date format: " +
          this.getAppContext().momentjs().format("L LT"),
      });
    }
  }

  handleSwitchError(value) {
    this.setState(
      {
        switchError: value == "errors" ? true : false,
        customYrefModal: undefined,
      },
      () => {
        this.loadStepBatch(this.state.switchError);
      },
    );
  }

  getPopupErrorInfo(stat, popupData) {
    const { errors_count, measures_count, over10_count } =
      popupData.graphPopupData || {};
    let measuresInfo = "";
    let earlyInfo = "";
    let slowMeasures = "";
    if (over10_count && over10_count > 0) {
      slowMeasures = `(${over10_count} slow measure${
        over10_count > 1 ? "s" : ""
      }${slowMeasures})`;
    }
    if (measures_count > 0)
      measuresInfo = `${measures_count} measure${
        measures_count > 1 ? "s " : " "
      }${slowMeasures}`;
    if (stat && stat["DISCEARLY"])
      earlyInfo = `${stat["DISCEARLY"]} early drop by AP`;

    if (errors_count == 0 || !stat) {
      return <div>{measuresInfo}</div>;
    } else if (stat) {
      if (!stat["DISCEARLY"]) {
        return `${errors_count} error on ${measuresInfo}`;
      } else {
        let diff = errors_count - stat["DISCEARLY"];

        if (diff) {
          return (
            <>
              <div>{earlyInfo}</div>
              <div>{`${diff} error on ${measuresInfo}`}</div>
            </>
          );
        } else {
          return `${earlyInfo} on ${measuresInfo}`;
        }
      }
    }
  }

  checkFutureTime(etime) {
    const now =
      this._measureInfo.paused ||
      this._measureInfo.archived ||
      this.getAppContext().momentjs().unix();
    const normalizeToMinute = (epoch) => Math.floor(epoch / 60);
    return normalizeToMinute(etime) >= normalizeToMinute(now);
  }

  parseTime() {
    if (this._view_form && this._view_form.isInitialized()) {
      const is_preset = this._view_form.getEntry("is_preset");
      let from_ts =
        this.state.measure_graph &&
        this.state.measure_graph.viewRangeData &&
        this.state.measure_graph.viewRangeData.stime;

      let to_ts =
        this.state.measure_graph &&
        this.state.measure_graph.viewRangeData &&
        this.state.measure_graph.viewRangeData.etime;

      let _stime = from_ts
        ? this.getAppContext().momentjs(from_ts, "X").format("L LT")
        : "";

      let startDate = from_ts
        ? this.getAppContext().momentjs(from_ts, "X").format("L")
        : "";

      let _etime = to_ts
        ? this.getAppContext().momentjs(to_ts, "X").format("L LT")
        : "";

      let endDate = to_ts
        ? this.getAppContext().momentjs(to_ts, "X").format("L")
        : "";

      if (
        startDate == endDate &&
        !this.state.showInputTime &&
        is_preset == "yes"
      ) {
        let _text = to_ts
          ? _stime +
            " - " +
            this.getAppContext().momentjs(to_ts, "X").format("LT")
          : "";
        return _text;
      } else {
        let _text = _stime + " - " + _etime;
        return _text;
      }
    } else {
      return null;
    }
  }

  fillFrequencySwitchNotes(user_notes, freq_info) {
    if (freq_info) {
      freq_info.forEach((_C_freq_info, _C_idx) => {
        if (_C_freq_info.prev_f != "0" && _C_freq_info.switch_ts) {
          user_notes.push({
            ts: _C_freq_info.switch_ts,
            text:
              "Frequency switch from " +
              _C_freq_info.prev_f +
              " MHz to " +
              _C_freq_info.curr_f +
              " MHz",
            cssid: "system",
            type: "system",
          });
        }
      });
    }
  }

  getFreq(obj) {
    let freq = (
      <div>
        {Object.keys(obj).map((f, id) => {
          const channel = obj[f].chan || "-";
          const text = `Freq: ${f} MHz (Ch. ${channel})`;
          return <div key={id + "_frq"}>{text}</div>;
        })}
      </div>
    );
    return freq;
  }

  setErrorViewRange(errorViewRange, cb) {
    this.setState({ errorViewRange: errorViewRange }, () => cb());
  }

  checkValidYref(str) {
    const values = str.split(".");
    const regex = /^[+]?\d+([.]\d+)?$/;

    if (str == "0.0" || str == "0.") return false;
    if (values.length > 2) return false;
    if (values.length == 1) return regex.test(values[0]);
    if (values.length == 2)
      return regex.test(values[0]) && regex.test(values[1]);
  }

  onComponentDidMount() {
    const goBackTgas = this.getAppContext()
      .getLocalStorageService()
      .get("goBackTags");
    if (this.props.location?.state?.mlist) {
      this.getAppContext()
        .getLocalStorageService()
        .set("goBackTags", JSON.stringify(this.props.location?.state));
    } else if (!goBackTgas) {
      this.getAppContext().getLocalStorageService().remove("goBackTags");
    }

    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.callsSet = this.apiStore.newCallsSet({
      state_setter: this._getStateSetter(),
      calls_set: {
        probe_cst_sync_status: {
          api_id: "probe_cst_sync_status",
          datastore_key: "conf_set",
          static_data: { probeuid: this.props.match.params.probeuid },
        },
        get_step_graph: {
          api_id: "get_step_graph",
          loading_key: "loadingStepTiming",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid || "overal",
          },
          pre_datastore: (data) => {
            data.graphData.phases_colors = {
              measures: {},
              errors: {},
            };
            data.graphData.phases_sequence.forEach((entry, index) => {
              if (
                data.graphData.highlights &&
                data.graphData.highlights[entry]
              ) {
                data.graphData.phases_colors.measures[entry] =
                  data.graphData.highlights[entry];
              } else {
                data.graphData.phases_colors.measures[entry] =
                  this.phaseColors.measures[
                    parseInt(
                      (index *
                        (this.phaseColors.measures.length +
                          this.phaseColors.measures.length /
                            data.graphData.phases_sequence.length)) /
                        data.graphData.phases_sequence.length,
                    )
                  ];
                data.graphData.phases_colors.errors[entry] =
                  this.phaseColors.errors[
                    parseInt(
                      (index *
                        (this.phaseColors.errors.length +
                          this.phaseColors.errors.length /
                            data.graphData.phases_sequence.length)) /
                        data.graphData.phases_sequence.length,
                    )
                  ];
              }
            });
          },
        },
        get_step_graph_error: {
          api_id: "get_step_graph_error",
          loading_key: "loadingStepTiming",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid || "overal",
          },
          pre_datastore: (data) => {
            data.graphData.phases_colors = {
              measures: {},
              errors: {},
            };
            data.graphData.phases_sequence.forEach((entry, index) => {
              if (
                data.graphData.highlights &&
                data.graphData.highlights[entry]
              ) {
                data.graphData.phases_colors.measures[entry] =
                  data.graphData.highlights[entry];
              } else {
                data.graphData.phases_colors.measures[entry] =
                  this.phaseColors.measures[
                    parseInt(
                      (index *
                        (this.phaseColors.measures.length +
                          this.phaseColors.measures.length /
                            data.graphData.phases_sequence.length)) /
                        data.graphData.phases_sequence.length,
                    )
                  ];
                data.graphData.phases_colors.errors[entry] =
                  this.phaseColors.errors[
                    parseInt(
                      (index *
                        (this.phaseColors.errors.length +
                          this.phaseColors.errors.length /
                            data.graphData.phases_sequence.length)) /
                        data.graphData.phases_sequence.length,
                    )
                  ];
              }
            });
          },
        },
        get_measure_graph: {
          api_id: "get_measure_graph",
          datastore_key: "measure_graph",
          loading_key: "loading",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid || "overal",
          },
          pre_datastore: (data) => {
            // console.log("pre_data", data);

            if (this._pie_chart2) {
              this._pie_chart2.reset();
            }
            if (this._pie_chart) {
              this._pie_chart.reset();
            }
            data.graphData.phases_colors = {
              measures: {},
              errors: {},
            };
            data.graphData.phases_sequence.unshift("DISCEARLY");
            data.graphData.phases_sequence.forEach((entry, index) => {
              if (
                data.graphData.highlights &&
                data.graphData.highlights[entry]
              ) {
                data.graphData.phases_colors.measures[entry] =
                  data.graphData.highlights[entry];
              } else {
                data.graphData.phases_colors.measures[entry] =
                  this.phaseColors.measures[
                    parseInt(
                      (index *
                        (this.phaseColors.measures.length +
                          this.phaseColors.measures.length /
                            data.graphData.phases_sequence.length)) /
                        data.graphData.phases_sequence.length,
                    )
                  ];
                data.graphData.phases_colors.errors[entry] =
                  this.phaseColors.errors[
                    parseInt(
                      (index *
                        (this.phaseColors.errors.length +
                          this.phaseColors.errors.length /
                            data.graphData.phases_sequence.length)) /
                        data.graphData.phases_sequence.length,
                    )
                  ];
              }
            });
            this.fillFrequencySwitchNotes(
              data.notes,
              data.graphData.freq_changes,
            );

            return data;
          },
        },
        get_error_graph: {
          api_id: "get_error_graph",
          datastore_key: "errorGraph",
          loading_key: "loadingErrorGraph",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid || "overal",
          },
        },
        get_measure_graph_popup: {
          api_id: "get_measure_graph_popup",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: this.props.match.params.bssid || "overal",
          },
        },
        get_measure_note: {
          api_id: "get_measure_note",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
        create_measure_note: {
          api_id: "create_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
        set_measure_note: {
          api_id: "set_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
        delete_measure_note: {
          api_id: "delete_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
          },
        },
      },
    });

    if (
      this.props.match.params.initview &&
      /^\d+$/.test(this.props.match.params.initview)
    ) {
      this.getAppContext()
        .getLocalStorageService()
        .set("measure_graph_view", {
          view_preset: parseInt(this.props.match.params.initview),
          is_preset: "yes",
        });
      this.getAppContext().redirectTo(
        "/" +
          this.props.match.params.probeuid +
          "/" +
          this.props.match.params.status +
          "/" +
          this.props.match.params.measureid +
          "/" +
          (this.props.match.params.bssid || "overal"),
        true,
      );
    }
    this._view_form.init();
    this._view_form.submit();
  }

  handleValue() {
    return this.state.inputFieldValue !== undefined
      ? this.state.inputFieldValue
      : this.state.measure_graph.Yref;
  }

  handleValueModal() {
    return this.state.inputFieldValueModal !== undefined
      ? this.state.inputFieldValueModal
      : this.state.measure_graph.Yref;
  }

  handleErrorGraphValueModal() {
    return this.state.ErrorGraphValue !== undefined
      ? this.state.ErrorGraphValue
      : "100";
  }

  handleCustomRange() {
    return this.state.range !== undefined ? this.state.range : this.parseTime();
  }

  stopLoadingIMG() {
    this.setState({ loadingIMG: false, loading: false });
  }

  delay(time, yref) {
    if (time == this.globalTime && !this.state.invalidYref) {
      if (!this.state.showErrorGraph) {
        this.setState({
          customYrefModal: yref.replace(/,/g, "."),
          startSpin: false,
        });
        this.loadStepBatch(this.state.switchError);
      } else {
        this.setState({
          customErrorYref: yref.replace(/,/g, "."),
          startSpin: false,
        });
        this._view_form.submit();
      }
    }
  }

  loadStepBatch(isError) {
    let viewrange = this.getAppContext()
      .getLocalStorageService()
      .get("measure_steplist_view");
    if (isError) {
      // urlToFetch = "get_step_graph_error";
      viewrange = { ...this.state.errorViewRange };
    }
    this.setState({ loadingIMG: true });

    let dataModal;

    if (this._stepTiming_modal.isOpen()) {
      dataModal = this._stepTiming_modal.getData();
    }

    let raw_step_graph = { ...this.state.step_graph };
    let stepToUpdate;

    let { arrayOfErrors } = this.state;

    arrayOfErrors.push("rssi", "overlap");

    if (isError) {
      Object.keys(raw_step_graph).forEach((step) => {
        if (raw_step_graph[step] != null && !arrayOfErrors.includes(step)) {
          raw_step_graph[step] = {
            ...raw_step_graph[step],
            msg: "No error",
            display: raw_step_graph[step].display,
          };
        } else if (
          raw_step_graph[step] == null &&
          !arrayOfErrors.includes(step)
        ) {
          raw_step_graph[step] = {
            ...raw_step_graph[step],
            msg: "No error",
            display: false,
          };
        }
      });
      // console.log("raw_step_graph", raw_step_graph);
      stepToUpdate = Object.keys(raw_step_graph).filter((step) => {
        return raw_step_graph[step] != null && !raw_step_graph[step].msg;
      });
    } else {
      stepToUpdate = Object.keys(raw_step_graph).filter((step) => {
        return raw_step_graph[step] != null;
      });
    }

    // console.log("raw_step_graph", raw_step_graph);

    // console.log("stepToUpdate", stepToUpdate);

    if (stepToUpdate.length > 0) {
      stepToUpdate.forEach((step) => {
        let urlToFetch = "get_step_graph";
        let yref;
        let customYref = this.state.customYrefModal || this.state.customYref;
        if (isError) {
          yref = this.state.maxErrorPerHour.maxValue + 1;

          if (customYref) {
            yref = customYref.toString().replace(/,/g, ".");
            if (customYref == "MAX") {
              yref = this.state.maxErrorPerHour[step] + 1;
            }
          }

          // this.setState({ inputFieldValueModal: this.state.maxErrorPerHour.maxValue });
        } else {
          if (customYref) {
            if (customYref == "MAX") {
              if (this.state.measure_graph.graphData.max_step_timing[step]) {
                yref =
                  (this.state.measure_graph.graphData.max_step_timing[step] +
                    1) /
                  1000;
              } else {
                yref = this.state.measure_graph.Yref;
              }
            } else if (customYref == "AVG2") {
              let avg = parseFloat(
                this.state.measure_graph.graphData.phases_timing[step],
              );
              yref = (avg * 2) / 1000;
            } else {
              yref = customYref.toString().replace(/,/g, ".");
            }
          }
        }

        if ((step == "rssi" || step == "overlap") && !customYref) {
          yref =
            (this.state.measure_graph.graphData.max_step_timing[step] + 1) /
            1000;
        }

        if (isError && step != "rssi" && step != "overlap") {
          urlToFetch = "get_step_graph_error";
        }

        this.callsSet.call(urlToFetch, {
          data_input: {
            viewrange: viewrange,
            stepList: [step],
            Yref: yref || undefined,
          },
          on_success: (_, response_data) => {
            let { ImgExtH, ImgExtW, ImgIntH, ImgIntW, ImgName, ImgPath } =
              response_data[0].data.graphData;
            // console.log(
            //   "response_data[0].data.graphData;",
            //   response_data[0].data.graphData
            // );
            raw_step_graph[step] = {
              ImgExtH,
              ImgExtW,
              ImgIntH,
              ImgIntW,
              ImgName,
              ImgPath,
              step,
              display: this.state.step_graph[step].display,
            };

            dataModal = response_data[0].data;
            this.setState({
              inputFieldValueModal:
                customYref || yref || this.state.measure_graph.yref,
            });

            this.setState(
              (prev_state) => {
                prev_state.step_graph = raw_step_graph;
                return prev_state;
              },
              () => {
                this._stepTiming_modal.updateData(dataModal);
              },
            );
          },
        });
      });
    } else {
      this.setState(
        (prev_state) => {
          prev_state.step_graph = raw_step_graph;
          return prev_state;
        },
        () => {
          // console.log("this.state.loadingStepTiming", this.state.loadingStepTiming);
          this._stepTiming_modal.updateData(dataModal);
        },
      );
    }
  }

  loadSteptiming(step, isError) {
    let viewrange = this.getAppContext()
      .getLocalStorageService()
      .get("measure_steplist_view");
    if (isError) {
      // urlToFetch = "get_step_graph_error";
      viewrange = { ...this.state.errorViewRange };
    }
    let yref;
    let customYref = this.state.customYrefModal || this.state.customYref;

    if (isError) {
      yref = this.state.maxErrorPerHour.maxValue + 1;

      if (customYref) {
        yref = customYref.toString().replace(/,/g, ".");
        if (customYref == "MAX") {
          yref = this.state.maxErrorPerHour[step] + 1;
        }
      }

      // this.setState({ inputFieldValueModal: this.state.maxErrorPerHour.maxValue });
    } else {
      if (customYref) {
        if (customYref == "MAX") {
          if (this.state.measure_graph.graphData.max_step_timing[step]) {
            yref =
              (this.state.measure_graph.graphData.max_step_timing[step] + 1) /
              1000;
          } else {
            yref = this.state.measure_graph.Yref;
          }
        } else if (customYref == "AVG2") {
          let avg = parseFloat(
            this.state.measure_graph.graphData.phases_timing[step],
          );
          yref = (avg * 2) / 1000;
        } else {
          yref = customYref.toString().replace(/,/g, ".");
        }
      }
    }

    if (step == "rssi" || step == "overlap") {
      yref =
        (this.state.measure_graph.graphData.max_step_timing[step] + 1) / 1000;
    }
    let urlToFetch = "get_step_graph";
    if (isError && step != "rssi" && step != "overlap") {
      urlToFetch = "get_step_graph_error";
    }

    this.callsSet.call(urlToFetch, {
      data_input: {
        viewrange: viewrange,
        stepList: [step],
        Yref: yref,
      },
      on_success: (_, response_data) => {
        if (customYref != "MAX" && customYref != "AVG2") {
          this.setState({
            inputFieldValueModal: yref,
          });
        }

        if (this.state.timingView == false) {
          let { ImgExtH, ImgExtW, ImgIntH, ImgIntW, ImgName, ImgPath } =
            response_data[0].data.graphData;
          let step_graph = {};
          let formInit = {};
          response_data[0].data.graphData.phases_sequence.forEach((phase) => {
            step == phase && (formInit[phase] = step);
            // formInit[phase] = step == phase ? phase : "off";
            step_graph[phase] =
              step == phase
                ? {
                    ImgExtH,
                    ImgExtW,
                    ImgIntH,
                    ImgIntW,
                    ImgName,
                    ImgPath,
                    phase,
                    display: true,
                  }
                : null;
          });

          if (this.state.measure_graph.essid != "Ethernet") {
            step_graph.rssi = null;
            step_graph.overlap = null;
          }

          // if (this._errorGraph_modal.isOpen()) {
          //   this.setState({
          //     inputFieldValueModal: customYref || yref || this.state.measure_graph.yref,
          //   });
          // }
          this.setState({ step_graph: step_graph });
          response_data[0].data.formInit = formInit;
          this._stepTiming_modal.open(response_data[0].data);
        } else {
          let { ImgExtH, ImgExtW, ImgIntH, ImgIntW, ImgName, ImgPath } =
            response_data[0].data.graphData;

          this.setState((prev_state) => {
            prev_state.step_graph[step] = {
              ImgExtH,
              ImgExtW,
              ImgIntH,
              ImgIntW,
              ImgName,
              ImgPath,
              step,
              display: true,
            };
            return prev_state;
          });
        }
      },
    });
  }

  parseCustomYref() {
    let yref = undefined;
    if (this.state.customYref == "MAX") {
      if (
        this.state.measure_graph.graphData &&
        this.state.measure_graph.graphData.max_measure_timing
      ) {
        yref =
          (this.state.measure_graph.graphData.max_measure_timing + 1) / 1000;
      } else {
        yref = this.state.measure_graph.Yref;
      }
    } else if (this.state.customYref == "AVG2") {
      if (this._total_avg_time) {
        yref = (this._total_avg_time * 2) / 1000;
      } else {
        yref = this.state.measure_graph.Yref;
      }
    } else {
      yref = this.state.customYref.toString().replace(/,/g, ".");
    }

    return yref;
  }

  loadMeasureGraph(data, cb, opt) {
    // console.log("state", this.state);
    let dataToSend = { ...data };

    delete dataToSend.snapStime;
    delete dataToSend.snapEtime;

    // const currentStime =
    //   data?.stime || this.state.measure_graph?.viewRangeData?.stime || 0;
    // const currentEtime =
    //   data?.etime || this.state.measure_graph?.viewRangeData?.etime || 0;
    if (dataToSend.is_preset == "yes") {
      // dataToSend.etime && delete dataToSend.etime;
      // dataToSend.stime && delete dataToSend.stime;
      !dataToSend.offset &&
        dataToSend.timeSnapshot &&
        delete dataToSend.timeSnapshot;
    }

    // Handle Time Limit
    let outOfLimit = false;
    let infoMsg = "";
    // console.log("PROPS::", this.props);
    // console.log("STATE::", this.state);
    // console.log("INFO::", this._measureInfo.archived);
    // parse start time
    let start_TS;
    if (data.offset) {
      if (data.is_preset == "yes") {
        start_TS = parseInt(
          dataToSend.timeSnapshot - dataToSend.view_preset + dataToSend.offset,
        );
      } else {
        start_TS = parseInt(dataToSend.stime + dataToSend.offset);
      }
      // delete dataToSend.offset;
      // dataToSend.is_preset = "no";
      // dataToSend.stime = currentStime + data.offset;
      // dataToSend.etime = currentEtime + data.offset;
      // delete dataToSend.offset;
      // console.log("se", dataToSend.stime, dataToSend.etime);
    } else if (!dataToSend.offset && dataToSend.is_preset == "no") {
      start_TS = parseInt(dataToSend.stime);
    }

    // check start time
    if (start_TS) {
      // console.log("start_TS", start_TS);
      // if (this.getAppContext().handleTSLimit(start_TS).unsafeTime) {
      //   infoMsg = this.getAppContext().handleTSLimit(start_TS).infoMsg;
      //   // console.log("unsafe", infoMsg);
      // }
      if (
        this.getAppContext().handleTSLimit(start_TS, this._measureInfo.archived)
          .outOfLimit
      ) {
        outOfLimit = true;
        infoMsg = this.getAppContext().handleTSLimit(
          start_TS,
          this._measureInfo.archived,
        ).infoMsg;
        let end_TS;
        if (data.is_preset == "no" && data.offset) {
          end_TS = parseInt(data.etime + data.offset);
        } else if (data.is_preset == "no" && !data.offset) {
          end_TS =
            data.etime >
            this.getAppContext().handleTSLimit(
              start_TS,
              this._measureInfo.archived,
            ).limit
              ? parseInt(data.etime)
              : parseInt(
                  this.getAppContext().handleTSLimit(
                    start_TS,
                    this._measureInfo.archived,
                  ).limit +
                    3600 * 4,
                );
        } else if (data.is_preset == "yes" && data.offset) {
          end_TS = parseInt(data.timeSnapshot);
        }

        dataToSend.etime = end_TS;
        dataToSend.is_preset = "no";
        dataToSend.stime = parseInt(
          this.getAppContext().handleTSLimit(
            start_TS,
            this._measureInfo.archived,
          ).limit,
        );
        dataToSend.view_preset = "no";

        this._view_form.handleFormChange("offset", false);
        this._view_form.handleFormChange("timeSnapshot", false);
        this._view_form.handleFormChange("is_preset", "no");
        this._view_form.handleFormChange(
          "stime",
          this.getAppContext().handleTSLimit(start_TS).limit,
        );
        this._view_form.handleFormChange("etime", end_TS);
      }
    }

    let yref = undefined;
    if (this.state.customYref) {
      yref = this.parseCustomYref();
    }

    // if (!data.offset && data.snapStime && data.snapEtime) {
    //   console.log("??????????????????", data);
    //   dataToSend.stime = parseInt(data.snapStime);
    //   dataToSend.etime = parseInt(data.snapEtime);

    //   delete dataToSend.snapStime;
    //   delete dataToSend.snapEtime;
    // }
    let etime = data.etime;
    let stime = data.stime;
    // check isFuture
    if (data.is_preset != "yes") {
      if (this.checkFutureTime(data.stime)) {
        const now = this.getAppContext().momentjs().unix();
        stime = now - 3600 * 4;
        dataToSend.stime = parseInt(stime);
        infoMsg =
          "Measure not available beyond: " +
          this.getAppContext().momentjs(etime, "X").format("L LT");
      }

      if (this.checkFutureTime(data.etime)) {
        etime =
          this._measureInfo.paused ||
          this._measureInfo.archived ||
          this.getAppContext().momentjs().unix();
        console.log("etime", etime);
        dataToSend.etime = parseInt(etime);
        infoMsg =
          "Measure not available beyond: " +
          this.getAppContext().momentjs(etime, "X").format("L LT");
      }
    }
    // if (data.is_preset != "yes" && this.checkFutureTime(data.etime)) {

    // }

    // console.log("data to send", dataToSend);

    // this.setState({ loading: true });
    delete dataToSend.offset;
    if (!this.state.showErrorGraph) {
      let viewrange = { ...dataToSend };
      // Prepare TS
      if (viewrange.stime) {
        viewrange.stime = dataToSend.stime - (dataToSend.stime % 60);
      }
      if (viewrange.etime) {
        viewrange.etime = dataToSend.etime - (dataToSend.etime % 60);
      }
      if (viewrange.snapStime) {
        viewrange.snapStime = data.snapStime - (dataToSend.snapStime % 60);
      }
      this.callsSet.call("get_measure_graph", {
        no_error_handle: opt ? opt.no_error_handle : false,
        data_input: {
          Yref: yref,
          viewrange,
        },
        on_success: () => {
          if (
            this.getAppContext()
              .getLocalStorageService()
              .isSet("errors_index_opened") &&
            this._errors_index_modal
          ) {
            if (
              /.*\/results\/.*/.test(
                this.getAppContext().router.getLastLocation(),
              )
            ) {
              this._errors_index_modal.open(
                this.getAppContext()
                  .getLocalStorageService()
                  .get("errors_index_opened"),
              );
            } else {
              this.getAppContext()
                .getLocalStorageService()
                .remove("errors_index_opened");
            }
          }

          this.setState({
            outOfLimit,
            infoMsg,
            ...(!this._IS_AUTO_RELOADING
              ? { showInputTime: false, range: undefined }
              : {}),
          });
        },
        on_end: (response_data) => {
          let stime = response_data[0].data.viewRangeData.stime;
          if (this.state.inputFieldValue == "") {
            this.setState({ inputFieldValue: undefined });
          } else if (
            this.state.inputFieldValue != "" &&
            this.state.inputFieldValue != undefined
          ) {
            this.setState({
              inputFieldValue: this.state.inputFieldValue
                .toString()
                .replace(/,/g, "."),
            });
          }
          if (this._IS_AUTO_RELOADING) {
            this._IS_AUTO_RELOADING = false;
          }
          if (this._AUTO_RELOAD_TIMEOUT) {
            clearTimeout(this._AUTO_RELOAD_TIMEOUT);
          }
          if (this.checkStartDateLoop) {
            clearTimeout(this.checkStartDateLoop);
          }
          if (data.is_preset == "yes" && !data.offset) {
            this._AUTO_RELOAD_TIMEOUT = setTimeout(() => {
              this._IS_AUTO_RELOADING = true;

              if (this.state.customYref) {
                this.setState(
                  {
                    inputFieldValue: this.parseCustomYref(),
                    customYref: this.parseCustomYref(),
                  },
                  () => {
                    this._view_form.submit(null, { no_error_handle: true });
                  },
                );
              } else {
                this._view_form.submit(null, { no_error_handle: true });
              }
            }, 60000);
          } else {
            if (stime) {
              this.checkStartDateLoop = setInterval(() => {
                if (this.getAppContext().handleTSLimit(stime).unsafeTime) {
                  let infoMsg =
                    this.getAppContext().handleTSLimit(stime).infoMsg;
                  this.setState({ infoMsg });
                }
              }, 100);
            }
          }
        },
      });
    } else {
      this.callsSet.call("get_error_graph", {
        no_error_handle: opt ? opt.no_error_handle : false,
        data_input: {
          Yref: this.state.customErrorYref ? this.state.customErrorYref : 100,
          viewrange: dataToSend,
        },
        on_success: (_, response_data) => {
          // console.log("Response Data from error", response_data);
          this.setState(
            {
              showErrorGraph: false,
            },
            () => {
              if (this._errorGraph_modal.isOpen()) {
                this._errorGraph_modal.updateData(response_data[0].data);
              } else {
                this._errorGraph_modal.open(response_data[0].data);
              }
            },
          );
        },
      });
    }
    this.callsSet.call("probe_cst_sync_status");
  }

  loadErrorGraph(data) {
    this.callsSet.call("get_error_graph", {
      // no_error_handle: opt ? opt.no_error_handle : false,
      data_input: {
        Yref: this.state.customErrorYref ? this.state.customErrorYref : 100,
        viewrange: data,
      },
      on_success: (_, response_data) => {
        // console.log("Response Data from error", response_data);
        if (this._errorGraph_modal.isOpen()) {
          this._errorGraph_modal.updateData(response_data[0].data);
        } else {
          this._errorGraph_modal.open(response_data[0].data);
        }
      },
    });
  }

  setActivePopup(tick_data) {
    tick_data.notes = this._explorerParameters._notes.filter((value) => {
      return (
        value.ts >= tick_data.ts &&
        value.ts < tick_data.ts + this._explorerParameters._divider
      );
    });
    this.setState(
      {
        _activePopup: tick_data,
        outOfLimitPopup: this.getAppContext().handleTSLimit(tick_data.ts)
          .outOfLimit,
      },
      () => {
        if (!tick_data._is_zoom) {
          if (
            this.state._popupData[
              this.props.match.params.probeuid +
                "_" +
                this.props.match.params.measureid +
                "_" +
                this.props.match.params.bssid +
                "_" +
                tick_data.ts
            ]
          ) {
            this.setState((prev_state) => {
              prev_state._activePopup.data =
                this.state._popupData[
                  this.props.match.params.probeuid +
                    "_" +
                    this.props.match.params.measureid +
                    "_" +
                    this.props.match.params.bssid +
                    "_" +
                    tick_data.ts
                ];
              return prev_state;
            });
          } else {
            if (this._popupLoadingTimeout) {
              clearTimeout(this._popupLoadingTimeout);
            }
            this._popupLoadingTimeout = setTimeout(() => {
              this.setState(
                {
                  loading_popup: true,
                },
                () => {
                  this.callsSet.call("get_measure_graph_popup", {
                    data_input: {
                      ts: tick_data.ts,
                    },
                    on_success: (_, response_data) => {
                      response_data[0].data.graphPopupData.phases_colors = {};
                      response_data[0].data.graphPopupData.phases_sequence.forEach(
                        (entry, index) => {
                          response_data[0].data.graphPopupData.phases_colors[
                            entry
                          ] =
                            this.state.measure_graph.graphData.highlights &&
                            this.state.measure_graph.graphData.highlights[entry]
                              ? this.state.measure_graph.graphData.highlights[
                                  entry
                                ]
                              : this.phaseColors.measures[
                                  parseInt(
                                    (index *
                                      (this.phaseColors.measures.length +
                                        this.phaseColors.measures.length /
                                          response_data[0].data.graphPopupData
                                            .phases_sequence.length)) /
                                      response_data[0].data.graphPopupData
                                        .phases_sequence.length,
                                  )
                                ];
                        },
                      );
                      if (this.mounted) {
                        this.setState((prev_state) => {
                          prev_state._popupData[
                            this.props.match.params.probeuid +
                              "_" +
                              this.props.match.params.measureid +
                              "_" +
                              this.props.match.params.bssid +
                              "_" +
                              tick_data.ts
                          ] = response_data[0].data;
                          prev_state.loading_popup = false;
                          return prev_state;
                        });
                      }
                    },
                  });
                },
              );
            }, 500);
          }
        }
      },
    );
  }

  unsetActivePopup(tick_data) {
    this.setState(
      {
        _activePopup: null,
      },
      () => {
        if (this._popupLoadingTimeout) {
          clearTimeout(this._popupLoadingTimeout);
        }
      },
    );
  }

  formatOffset(seconds) {
    if (seconds == 0) {
      return "";
    }
    let isFuture = seconds < 0 ? false : true;
    seconds = seconds < 0 ? seconds * -1 : seconds;
    let weeks = parseInt(seconds / 60 / 60 / 24 / 7);
    let weeksStr = weeks + " week" + (weeks > 1 ? "s" : "");
    let days = parseInt(seconds / 60 / 60 / 24) % 7;
    let daysStr = days + " day" + (days > 1 ? "s" : "");
    let hours = parseInt(seconds / 60 / 60) % 24;
    let hoursStr = hours + " hour" + (hours > 1 ? "s" : "");
    let minutes = parseInt(seconds / 60) % 60;
    let minutesStr = minutes + " minute" + (minutes > 1 ? "s" : "");
    return (
      (!isFuture ? "- " : "+ ") +
      (weeks > 0 ? weeksStr + " " : "") +
      (days > 0 ? daysStr + " " : "") +
      (hours > 0 ? hoursStr + " " : "") +
      (minutes > 0 ? minutesStr + " " : "")
    );
  }

  onComponentWillUnmount() {
    this.mounted = false;
    if (this._AUTO_RELOAD_TIMEOUT) {
      clearTimeout(this._AUTO_RELOAD_TIMEOUT);
    }
    if (this._popupLoadingTimeout) {
      clearTimeout(this._popupLoadingTimeout);
    }
    if (this.checkStartDateLoop) {
      clearTimeout(this.checkStartDateLoop);
    }
  }

  downloadCsv(bssid, csv) {
    this.setState(
      {
        loading_csv: true,
      },
      () => {
        this.apiStore.fire("download_csv", {
          filename: csv,
          data: {
            probeuid: this.props.match.params.probeuid,
            measureid: this.props.match.params.measureid,
            bssid: bssid,
            csv: csv,
          },
          ___onEnd: () => {
            setTimeout(() => {
              this.setState({
                loading_csv: false,
              });
            }, 5000);
          },
        });
      },
    );
  }

  onRender() {
    let _popup = (position) => {
      return this.state._activePopup ? (
        !this.state._activePopup._is_zoom ? (
          (() => {
            let popupData =
              this.state._popupData[
                this.props.match.params.probeuid +
                  "_" +
                  this.props.match.params.measureid +
                  "_" +
                  this.props.match.params.bssid +
                  "_" +
                  this.state._activePopup.ts
              ];
            let _errors_stat =
              this.state.measure_graph.graphData.errors_statistics.details[
                this.state._activePopup.ts + 60
              ];

            return (
              <Panel
                className="graph-explorer-popup-detail border-0"
                rounded
                bodyClassName="p-0"
                header={
                  !this.state.outOfLimitPopup && (
                    <div className="text-center text-light">
                      <div className="d-flex">
                        {position == "static"
                          ? (() => {
                              let _nextTick =
                                this._explorerParameters._ticks_list.find(
                                  (value) => {
                                    return (
                                      value == this.state._activePopup.ts - 60
                                    );
                                  },
                                );
                              let _nextTickIdx =
                                this._explorerParameters._ticks_list.indexOf(
                                  _nextTick,
                                );
                              return (
                                <div>
                                  <ReactOButton
                                    icon="navigate-prev"
                                    disabled={!_nextTick}
                                    onClick={() => {
                                      this.setActivePopup({
                                        ts: _nextTick,
                                        ts_end:
                                          _nextTick +
                                          this._explorerParameters._divider,
                                        retention_ts_range:
                                          this.state.measure_graph.graphData
                                            .rrd_step > 60
                                            ? {
                                                ts:
                                                  _nextTick -
                                                  this.state.measure_graph
                                                    .graphData.rrd_step /
                                                    2,
                                                ts_end:
                                                  _nextTick -
                                                  this.state.measure_graph
                                                    .graphData.rrd_step /
                                                    2 +
                                                  this._explorerParameters
                                                    ._divider,
                                              }
                                            : undefined,
                                        tick_x:
                                          this._explorerParameters._tick_width *
                                            _nextTickIdx -
                                          (this.state.measure_graph.graphData
                                            .rrd_step > 60 && _nextTickIdx > 0
                                            ? this._explorerParameters
                                                ._tickLast_width
                                            : 0),
                                        tick_width:
                                          this.state.measure_graph.graphData
                                            .rrd_step > 60
                                            ? _nextTickIdx == 0
                                              ? this._explorerParameters
                                                  ._tickFirst_width
                                              : _nextTickIdx ==
                                                  this._explorerParameters
                                                    ._ticks_list.length -
                                                    1
                                                ? this._explorerParameters
                                                    ._tickLast_width
                                                : this._explorerParameters
                                                    ._tick_width
                                            : this._explorerParameters
                                                ._tick_width,
                                        _is_zoom:
                                          this.state._activePopup._is_zoom,
                                      });
                                    }}
                                  />
                                </div>
                              );
                            })()
                          : null}
                        {position == "static" ? (
                          <div className="flex-grow-1">
                            <ReactOButton
                              onClick={() => {
                                let _currTick =
                                  this._explorerParameters._ticks_list.find(
                                    (value) => {
                                      return (
                                        value == this.state._activePopup.ts
                                      );
                                    },
                                  );
                                this.getAppContext().redirectTo(
                                  "/" +
                                    this.props.match.params.probeuid +
                                    "/" +
                                    this.props.match.params.status +
                                    "/" +
                                    this.props.match.params.measureid +
                                    "/" +
                                    this.props.match.params.bssid +
                                    "/results/" +
                                    _currTick +
                                    "/i",
                                );
                              }}
                            >
                              Details
                            </ReactOButton>
                          </div>
                        ) : null}
                        {position == "static"
                          ? (() => {
                              let _nextTick =
                                this._explorerParameters._ticks_list.find(
                                  (value) => {
                                    return (
                                      value == this.state._activePopup.ts + 60
                                    );
                                  },
                                );
                              let _nextTickIdx =
                                this._explorerParameters._ticks_list.indexOf(
                                  _nextTick,
                                );
                              return (
                                <div>
                                  <ReactOButton
                                    icon="navigate-next"
                                    disabled={!_nextTick}
                                    onClick={() => {
                                      this.setActivePopup({
                                        ts: _nextTick,
                                        ts_end:
                                          _nextTick +
                                          this._explorerParameters._divider,
                                        retention_ts_range:
                                          this.state.measure_graph.graphData
                                            .rrd_step > 60
                                            ? {
                                                ts:
                                                  _nextTick -
                                                  this.state.measure_graph
                                                    .graphData.rrd_step /
                                                    2,
                                                ts_end:
                                                  _nextTick -
                                                  this.state.measure_graph
                                                    .graphData.rrd_step /
                                                    2 +
                                                  this._explorerParameters
                                                    ._divider,
                                              }
                                            : undefined,
                                        tick_x:
                                          this._explorerParameters._tick_width *
                                            _nextTickIdx -
                                          (this.state.measure_graph.graphData
                                            .rrd_step > 60 && _nextTickIdx > 0
                                            ? this._explorerParameters
                                                ._tickLast_width
                                            : 0),
                                        tick_width:
                                          this.state.measure_graph.graphData
                                            .rrd_step > 60
                                            ? _nextTickIdx == 0
                                              ? this._explorerParameters
                                                  ._tickFirst_width
                                              : _nextTickIdx ==
                                                  this._explorerParameters
                                                    ._ticks_list.length -
                                                    1
                                                ? this._explorerParameters
                                                    ._tickLast_width
                                                : this._explorerParameters
                                                    ._tick_width
                                            : this._explorerParameters
                                                ._tick_width,
                                        _is_zoom:
                                          this.state._activePopup._is_zoom,
                                      });
                                    }}
                                  />
                                </div>
                              );
                            })()
                          : null}
                      </div>
                      <div className={position == "static" ? "mt-2" : ""}>
                        <span className="icon-calendar mr-2" />
                        {this.getAppContext()
                          .momentjs(this.state._activePopup.ts, "X")
                          .format("L LT")}
                        {popupData &&
                        popupData.graphPopupData.measures_count > 0 ? (
                          <div
                            className={
                              "sub-title" +
                              (popupData.graphPopupData.errors_count > 0
                                ? popupData.graphPopupData.errors_count ==
                                  popupData.graphPopupData.measures_count
                                  ? " text-danger"
                                  : " text-warning"
                                : " text-light")
                            }
                          >
                            {popupData?.graphPopupData
                              ? this.getPopupErrorInfo(_errors_stat, popupData)
                              : "-"}
                            {/* {popupData.graphPopupData.errors_count > 0
                              ? popupData.graphPopupData.errors_count +
                                " error on " +
                                popupData.graphPopupData.measures_count +
                                " measure"
                              : popupData.graphPopupData.measures_count > 0
                              ? popupData.graphPopupData.measures_count + " measure"
                              : null} */}
                          </div>
                        ) : null}
                      </div>
                      {this.state._activePopup.notes.length ? (
                        <div
                          className={
                            "my-2 p-2 text-left rounded" +
                            (this.state._activePopup.notes.length == 1 &&
                            this.state._activePopup.notes[0].type == "system"
                              ? " bg-info"
                              : " bg-secondary")
                          }
                        >
                          <small>
                            {this.state._activePopup.notes.map(
                              (_C_note, _C_idx) => {
                                return (
                                  <div
                                    key={_C_idx}
                                    className={
                                      "d-flex" +
                                      (_C_idx !=
                                      this.state._activePopup.notes.length - 1
                                        ? " border-bottom border-gray500"
                                        : "")
                                    }
                                  >
                                    <div
                                      className="flex-grow-1"
                                      style={{ maxWidth: "270px" }}
                                    >
                                      <div
                                        className={
                                          "font-weight-normal text-wrap" +
                                          (_C_note.type == "system"
                                            ? " font-italic"
                                            : "")
                                        }
                                      >
                                        {_C_note.text}
                                      </div>
                                    </div>
                                  </div>
                                );
                              },
                            )}
                          </small>
                        </div>
                      ) : null}
                    </div>
                  )
                }
              >
                {!this.state.outOfLimitPopup ? (
                  <div>
                    <_LoadingWrapper
                      loadingPlug={!popupData}
                      showOverlay={false}
                    >
                      <div className="p-3">
                        {popupData
                          ? (() => {
                              if (
                                popupData.graphPopupData.measures_count == 0 &&
                                popupData.graphPopupData.errors_count == 0
                              ) {
                                return (
                                  <div className="sub-title text-center text-gray400">
                                    No measures done.
                                    <br />
                                    Out of connection criteria
                                    {popupData.graphPopupData.rssi != "0" ? (
                                      <div className="mt-4 pt-1 border-top border-1 border-gray600 text-gray400">
                                        <small>
                                          <Row noGutters>
                                            <div className="popup-detail-phase-color">
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "0px",
                                                  width: "2px",
                                                  height: "14px",
                                                  border: "1px solid #de514e",
                                                  borderWidth: "0 0 1px 0",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "5px",
                                                  width: "3px",
                                                  height: "14px",
                                                  border: "1px solid #de514e",
                                                  borderWidth: "1px 1px 0 1px",
                                                }}
                                              />
                                            </div>
                                            <Col className="flex-grow-1 mr-3">
                                              RSSI:
                                            </Col>
                                            <Col className="mr-2 text-right">
                                              <strong>
                                                {popupData.graphPopupData.rssi}
                                              </strong>
                                            </Col>
                                            <strong className="popup-detail-phase-unit">
                                              dBm
                                            </strong>
                                            <div className="popup-detail-phase-error-label" />
                                          </Row>
                                          <Row noGutters>
                                            <div className="popup-detail-phase-color">
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "0px",
                                                  width: "2px",
                                                  height: "14px",
                                                  border: "1px solid #FFA559",
                                                  borderWidth: "0 0 1px 0",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "5px",
                                                  width: "3px",
                                                  height: "14px",
                                                  border: "1px solid #FFA559",
                                                  borderWidth: "1px 1px 0 1px",
                                                }}
                                              />
                                            </div>
                                            <Col className="flex-grow-1 mr-3">
                                              Overlap:
                                            </Col>
                                            <Col className="mr-2 text-right">
                                              <strong>
                                                {
                                                  popupData.graphPopupData
                                                    .overlap
                                                }
                                              </strong>
                                            </Col>
                                            <div className="popup-detail-phase-unit" />
                                            <div className="popup-detail-phase-error-label" />
                                          </Row>
                                        </small>
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              } else if (
                                !popupData.graphPopupData.measures_count &&
                                !popupData.graphPopupData.errors_count
                              ) {
                                return (
                                  <div className="sub-title text-center text-gray400">
                                    No measures done
                                    {popupData.graphPopupData.rssi != "0" ? (
                                      <div className="mt-4 pt-1 border-top border-1 border-gray600 text-gray400">
                                        <small>
                                          <Row noGutters>
                                            <div className="popup-detail-phase-color">
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "0px",
                                                  width: "2px",
                                                  height: "14px",
                                                  border: "1px solid #de514e",
                                                  borderWidth: "0 0 1px 0",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "5px",
                                                  width: "3px",
                                                  height: "14px",
                                                  border: "1px solid #de514e",
                                                  borderWidth: "1px 1px 0 1px",
                                                }}
                                              />
                                            </div>
                                            <Col className="flex-grow-1 mr-3">
                                              RSSI:
                                            </Col>
                                            <Col className="mr-2 text-right">
                                              <strong>
                                                {popupData.graphPopupData.rssi}
                                              </strong>
                                            </Col>
                                            <strong className="popup-detail-phase-unit">
                                              dBm
                                            </strong>
                                            <div className="popup-detail-phase-error-label" />
                                          </Row>
                                          <Row noGutters>
                                            <div className="popup-detail-phase-color">
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "0px",
                                                  width: "2px",
                                                  height: "14px",
                                                  border: "1px solid #FFA559",
                                                  borderWidth: "0 0 1px 0",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "5px",
                                                  width: "3px",
                                                  height: "14px",
                                                  border: "1px solid #FFA559",
                                                  borderWidth: "1px 1px 0 1px",
                                                }}
                                              />
                                            </div>
                                            <Col className="flex-grow-1 mr-3">
                                              Overlap:
                                            </Col>
                                            <Col className="mr-2 text-right">
                                              <strong>
                                                {
                                                  popupData.graphPopupData
                                                    .overlap
                                                }
                                              </strong>
                                            </Col>
                                            <div className="popup-detail-phase-unit" />
                                            <div className="popup-detail-phase-error-label" />
                                          </Row>
                                        </small>
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              } else if (
                                popupData.graphPopupData.measures_count == 0 &&
                                popupData.graphPopupData.errors_count > 0
                              ) {
                                return (
                                  <div className="sub-title text-center text-gray400">
                                    No measures done. <br />
                                    BSSID of ESSID not visible
                                  </div>
                                );
                              } else {
                                let _total = 0;
                                let errorMeasure;
                                return (
                                  <div>
                                    {popupData.graphPopupData.phases_sequence.map(
                                      (_CURR_phase, _CURR_idx) => {
                                        let className = "";
                                        _total = popupData.graphPopupData
                                          .phases_timing[_CURR_phase]
                                          ? _total +
                                            parseFloat(
                                              popupData.graphPopupData
                                                .phases_timing[_CURR_phase],
                                            )
                                          : _total;
                                        if (
                                          !errorMeasure &&
                                          _errors_stat &&
                                          _errors_stat[_CURR_phase]
                                        ) {
                                          errorMeasure =
                                            _errors_stat &&
                                            _errors_stat[_CURR_phase];
                                        }

                                        if (
                                          !errorMeasure &&
                                          !popupData.graphPopupData
                                            .phases_timing[_CURR_phase]
                                        ) {
                                          className = "text-gray500";
                                        }
                                        return (
                                          <Row
                                            key={_CURR_idx}
                                            noGutters
                                            className={
                                              _CURR_idx <
                                              popupData.graphPopupData
                                                .phases_sequence.length -
                                                1
                                                ? "mb-1 " + className
                                                : className
                                            }
                                          >
                                            <div
                                              className={
                                                "popup-detail-phase-color"
                                              }
                                              style={{
                                                backgroundColor:
                                                  popupData.graphPopupData
                                                    .phases_colors[_CURR_phase],
                                              }}
                                            ></div>
                                            <Col className="flex-grow-1 mr-3 ml-2">
                                              {_CURR_phase}
                                            </Col>
                                            <Col className="mr-2 text-right">
                                              {popupData.graphPopupData
                                                .phases_timing[_CURR_phase]
                                                ? popupData.graphPopupData
                                                    .phases_timing[_CURR_phase]
                                                : "-"}
                                            </Col>
                                            <div className="popup-detail-phase-unit">
                                              {popupData.graphPopupData
                                                .phases_timing[_CURR_phase]
                                                ? "ms"
                                                : ""}
                                            </div>
                                            <div className="popup-detail-phase-error-label">
                                              {_errors_stat &&
                                              _errors_stat[_CURR_phase] ? (
                                                <Badge color="danger">
                                                  {_errors_stat[_CURR_phase]}
                                                </Badge>
                                              ) : null}
                                            </div>
                                          </Row>
                                        );
                                      },
                                    )}
                                    <div className="mt-3 pt-1 border-top border-2 border-primary">
                                      <Row noGutters>
                                        <Col className="flex-grow-1 mr-3 text-right">
                                          TOTAL:
                                        </Col>
                                        <Col className="mr-2 text-right">
                                          <strong>
                                            {Math.round(_total * 10) / 10}
                                          </strong>
                                        </Col>
                                        <strong className="popup-detail-phase-unit">
                                          ms
                                        </strong>
                                        <div className="popup-detail-phase-error-label" />
                                      </Row>
                                    </div>
                                    {this.state.measure_graph.essid !=
                                    "Ethernet" ? (
                                      <div className="mt-3 pt-1 border-top border-1 border-gray600 text-gray400">
                                        <small>
                                          <Row noGutters>
                                            <div className="popup-detail-phase-color">
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "0px",
                                                  width: "2px",
                                                  height: "14px",
                                                  border: "1px solid #de514e",
                                                  borderWidth: "0 0 1px 0",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "5px",
                                                  width: "3px",
                                                  height: "14px",
                                                  border: "1px solid #de514e",
                                                  borderWidth: "1px 1px 0 1px",
                                                }}
                                              />
                                            </div>
                                            <Col className="flex-grow-1 mr-3">
                                              RSSI:
                                            </Col>
                                            <Col className="mr-2 text-right">
                                              <strong>
                                                {popupData.graphPopupData.rssi}
                                              </strong>
                                            </Col>
                                            <strong className="popup-detail-phase-unit">
                                              dBm
                                            </strong>
                                            <div className="popup-detail-phase-error-label" />
                                          </Row>
                                          <Row noGutters>
                                            <div className="popup-detail-phase-color">
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "0px",
                                                  width: "2px",
                                                  height: "14px",
                                                  border: "1px solid #FFA559",
                                                  borderWidth: "0 0 1px 0",
                                                }}
                                              />
                                              <div
                                                style={{
                                                  float: "left",
                                                  marginTop: "3px",
                                                  marginRight: "5px",
                                                  width: "3px",
                                                  height: "14px",
                                                  border: "1px solid #FFA559",
                                                  borderWidth: "1px 1px 0 1px",
                                                }}
                                              />
                                            </div>
                                            <Col className="flex-grow-1 mr-3">
                                              Overlap:
                                            </Col>
                                            <Col className="mr-2 text-right">
                                              <strong>
                                                {
                                                  popupData.graphPopupData
                                                    .overlap
                                                }
                                              </strong>
                                            </Col>
                                            <div className="popup-detail-phase-unit" />
                                            <div className="popup-detail-phase-error-label" />
                                          </Row>
                                        </small>

                                        {this.props.match.params.bssid !=
                                          "overal" &&
                                          popupData.freqs && (
                                            <div className="text-center sub-title border-top border-1 border-gray600 text-gray400 pt-2 mt-2">
                                              {this.getFreq(popupData.freqs)}
                                            </div>
                                          )}
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              }
                            })()
                          : null}
                      </div>
                    </_LoadingWrapper>
                    <div className="text-center sub-title text-gray200 bg-gray700 rounded-bottom font-italic p-2">
                      {position == "overlay" ? (
                        <small>
                          <span className="icon-lightbulb mr-2" />
                          Shift + Click to add note
                        </small>
                      ) : (
                        <ReactOButton
                          size="sm"
                          icon="pencil"
                          onClick={() => {
                            this._notes_editing_ctrl.createNoteAt(
                              this.state._activePopup.ts,
                            );
                          }}
                        >
                          Add note
                        </ReactOButton>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="p-4">
                    {
                      this.getAppContext().handleTSLimit(
                        this.state._activePopup.ts,
                      ).infoMsg
                    }
                  </div>
                )}
              </Panel>
            );
          })()
        ) : (
          <Panel
            className="graph-explorer-popup-zoom"
            rounded
            header={
              <div className="text-center text-light">
                {position == "overlay" ? (
                  "Zoom for details"
                ) : (
                  <ReactOButton
                    icon="zoom-in"
                    onClick={() => {
                      let _tick = this._explorerParameters._ticks_list.find(
                        (value) => {
                          return value == this.state._activePopup.ts;
                        },
                      );
                      let _tickIdx =
                        this._explorerParameters._ticks_list.indexOf(_tick);
                      let _isLastTick =
                        this._view_form.getEntry("is_preset") == "yes" &&
                        _tickIdx ==
                          this._explorerParameters._ticks_list.length - 1;
                      let _nextZoomViewPreset = 3600;

                      if (this._explorerParameters._range == 3600 * 24) {
                        _nextZoomViewPreset = 3600 * 4;
                      } else if (
                        this._explorerParameters._range ==
                        3600 * 24 * 7
                      ) {
                        _nextZoomViewPreset = 3600 * 24;
                      } else if (
                        this._explorerParameters._range ==
                        3600 * 24 * 7 * 4
                      ) {
                        _nextZoomViewPreset = 3600 * 24 * 7;
                      } else if (
                        this._explorerParameters._range != 3600 &&
                        this._explorerParameters._range != 3600 * 4
                      ) {
                        _nextZoomViewPreset = 3600 * 24;
                      }

                      this._view_form.handleFormChange(
                        "is_preset",
                        _isLastTick ? "yes" : "no",
                      );
                      this._view_form.handleFormChange(
                        "view_preset",
                        _isLastTick ? _nextZoomViewPreset : "no",
                      );
                      this._view_form.handleFormChange("offset", false);
                      if (!_isLastTick) {
                        this._view_form.handleFormChange(
                          "stime",
                          this.state._activePopup.ts,
                        );
                        this._view_form.handleFormChange(
                          "etime",
                          this.state._activePopup.ts_end,
                        );
                      }
                      this._view_form.submit();
                    }}
                  >
                    Zoom for details
                  </ReactOButton>
                )}
                {this.state._activePopup.notes.length ? (
                  <div className="my-2 p-2 text-left bg-secondary rounded">
                    <small>
                      {this.state._activePopup.notes.map((_C_note, _C_idx) => {
                        return (
                          <div
                            key={_C_idx}
                            className={
                              "d-flex" +
                              (_C_idx !=
                              this.state._activePopup.notes.length - 1
                                ? " border-bottom border-gray500"
                                : "")
                            }
                          >
                            <div
                              className="flex-grow-1"
                              style={{ maxWidth: "270px" }}
                            >
                              <div className="font-weight-normal text-wrap">
                                {_C_note.text}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </small>
                  </div>
                ) : null}
              </div>
            }
          >
            <Row noGutters>
              <Col xs={10}>
                <Row noGutters>
                  <Col xs={4} className="text-right pr-2">
                    From:
                  </Col>
                  <Col xs={8} className="text-nowrap">
                    {this.getAppContext()
                      .momentjs(this.state._activePopup.ts, "X")
                      .format("L LT")}
                  </Col>
                </Row>
                <Row noGutters>
                  <Col xs={4} className="text-right pr-2">
                    To:
                  </Col>
                  <Col xs={8} className="text-nowrap">
                    {this.getAppContext()
                      .momentjs(this.state._activePopup.ts_end, "X")
                      .format("L LT")}
                  </Col>
                </Row>
              </Col>
              <Col xs={2} className="align-self-center ">
                <span className="zoom-icon icon-zoom-in" />
              </Col>
            </Row>
          </Panel>
        )
      ) : position == "static" ? (
        <Panel className="graph-explorer-popup-zoom" rounded>
          <div className="text-center text-gray500">Tap chart for details</div>
        </Panel>
      ) : null;
    };

    return (
      <Section designType="wide">
        <Section
          designType="wide"
          className="mb-4 border-bottom border-3 border-gray300"
        >
          {(() => {
            this._measureInfo = {};
            if (this.state.measure_graph) {
              this._measureInfo = {
                name: this.state.measure_graph.name,
                essid: this.state.measure_graph.essid,
                archived: this.state.measure_graph.archived,
                paused: this.state.measure_graph.paused,
                bssid: this.state.measure_graph.graphData
                  ? this.state.measure_graph.graphData.bssid
                  : "",
                bssid_info:
                  this.state.measure_graph.graphData &&
                  this.state.measure_graph.graphData.bssid_info
                    ? this.state.measure_graph.graphData.bssid_info
                    : undefined,
                last_freq: this.state.measure_graph.graphData
                  ? this.state.measure_graph.graphData.last_freq
                  : "",
                connection_criteria:
                  this.state.measure_graph.connection_criteria,
                test: this.state.measure_graph.test,
                tags: this.state.measure_graph.tags || [],
              };
            }
            return (
              <div
                className={
                  "px-4 pt-4 pb-3" +
                  (this.getAppContext().media.isMobile ||
                  this.getAppContext().media.isTablet
                    ? ""
                    : " d-flex")
                }
              >
                <div className="flex-grow-1">
                  <div className="d-flex align-items-center">
                    <h2 className="mr-2">
                      {this._measureInfo.name ? (
                        <span>
                          <a
                            className="text-dark text-decoration-none"
                            href={`${this.getAppContext().conf.BASENAME}/${this.props.match.params.probeuid}/active/${this.props.match.params.measureid}`}
                          >
                            {this._measureInfo.name}
                          </a>
                          {!this.getAppContext().media.isMobile &&
                          !this.getAppContext().media.isTablet ? (
                            <span className="icon-navigate-next align-middle mx-1" />
                          ) : (
                            <br />
                          )}
                          {this.props.match.params.bssid == "overal" ? (
                            <span className="text-gray600">Overall chart</span>
                          ) : (
                            <span>
                              {this._measureInfo.bssid_info &&
                              this._measureInfo.bssid_info.ap_custom_data ? (
                                <strong>
                                  <span>
                                    {
                                      this._measureInfo.bssid_info
                                        .ap_custom_data.name
                                    }
                                  </span>
                                </strong>
                              ) : (
                                <strong>
                                  <span className="text-gray600">
                                    {this._measureInfo.bssid}
                                  </span>
                                </strong>
                              )}
                            </span>
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </h2>
                    {/ethernet/i.test(this.state.measure_graph.essid) ||
                    this.props.match.params.bssid == "overal" ? null : (
                      <div className="align-self-center">
                        <div className="d-flex align-items-center">
                          {this._measureInfo.bssid_info &&
                          this._measureInfo.bssid_info.ap_custom_data ? (
                            <strong>
                              <span className="mr-2 text-muted">
                                ({this._measureInfo.bssid})
                              </span>
                            </strong>
                          ) : (
                            ""
                          )}
                          {this._measureInfo.last_freq
                            ? this.getAppContext().freqToLabel(
                                this._measureInfo.last_freq,
                              )
                            : null}
                        </div>
                      </div>
                    )}
                  </div>
                  <small className="text-left d-flex align-items-center mt-2">
                    <Section
                      className={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? "flex-grow-1"
                          : ""
                      }
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                          ? 1
                          : 5
                      }
                      gridSpacing={1}
                      gridSpacingColor={this.getAppContext().colors.gray300}
                    >
                      <div
                        className={
                          "flex-shrink-1 py-1" +
                          (!this.getAppContext().media.isMobile &&
                          !this.getAppContext().media.isTablet
                            ? " px-2"
                            : "")
                        }
                      >
                        <strong className="text-muted">NETWORK:</strong>
                        <strong className="pl-2">
                          <span className="text-nowrap">
                            {this._measureInfo.essid || "-"}
                          </span>
                        </strong>
                      </div>
                      <div
                        className={
                          "flex-shrink-1 py-1" +
                          (!this.getAppContext().media.isMobile &&
                          !this.getAppContext().media.isTablet
                            ? " px-2"
                            : "")
                        }
                      >
                        <strong className="text-muted text-nowrap">
                          CONNECTION CRITERIA:
                        </strong>
                        <strong className="pl-2">
                          <span
                            id={
                              typeof this._measureInfo.connection_criteria ==
                              "object"
                                ? "_tooltip_multi_ap_conn_crit_"
                                : null
                            }
                          >
                            {typeof this._measureInfo.connection_criteria ==
                            "object" ? (
                              <span className="text-nowrap">
                                Multi AP
                                <ReactOTooltip
                                  placement="bottom"
                                  target="_tooltip_multi_ap_conn_crit_"
                                  text={Object.keys(
                                    this._measureInfo.connection_criteria,
                                  ).map((_C_bssid, _C_idx) => {
                                    return (
                                      <div key={_C_idx} className="text-nowrap">
                                        <strong>{_C_bssid}</strong>
                                        {this._measureInfo.connection_criteria[
                                          _C_bssid
                                        ] ? (
                                          <span className="text-muted ml-2">
                                            (
                                            {this._measureInfo
                                              .connection_criteria[_C_bssid]
                                              .ap_custom_data
                                              ? this._measureInfo
                                                  .connection_criteria[_C_bssid]
                                                  .ap_custom_data.name
                                              : this._measureInfo
                                                  .connection_criteria[_C_bssid]
                                                  .short_desc}
                                            )
                                          </span>
                                        ) : null}
                                      </div>
                                    );
                                  })}
                                />
                                <span className="sub-title icon-info ml-2" />
                              </span>
                            ) : this._measureInfo.connection_criteria ? (
                              <span className="text-nowrap">
                                {this._measureInfo.connection_criteria}
                              </span>
                            ) : (
                              "-"
                            )}
                          </span>
                        </strong>
                      </div>
                      <div
                        className={
                          "flex-shrink-1 py-1" +
                          (!this.getAppContext().media.isMobile &&
                          !this.getAppContext().media.isTablet
                            ? " px-2"
                            : "")
                        }
                      >
                        <strong className="text-muted">TEST:</strong>
                        <strong className="pl-2">
                          <span className="text-nowrap">
                            {this._measureInfo.test || "-"}
                          </span>
                        </strong>
                      </div>
                      {this.props.match.params.status == "paused" ? (
                        <div
                          className={
                            "flex-shrink-1 py-1 text-orange text-nowrap" +
                            (!this.getAppContext().media.isMobile &&
                            !this.getAppContext().media.isTablet
                              ? " px-2"
                              : "")
                          }
                        >
                          <strong className="">
                            <span className="icon-pause mr-2" />
                            PAUSED AT:
                          </strong>
                          <strong className="pl-2">
                            <span className="text-nowrap">
                              {this._measureInfo.paused
                                ? this.getAppContext()
                                    .momentjs(this._measureInfo.paused, "X")
                                    .format("L LT")
                                : "-"}
                            </span>
                          </strong>
                        </div>
                      ) : this.props.match.params.status == "archived" ? (
                        <div
                          className={
                            "flex-shrink-1 py-1 text-orange text-nowrap" +
                            (!this.getAppContext().media.isMobile &&
                            !this.getAppContext().media.isTablet
                              ? " px-2"
                              : "")
                          }
                        >
                          <strong className="">
                            <span className="icon-archive mr-2" />
                            ARCHIVED AT:
                          </strong>
                          <strong className="pl-2">
                            <span className="text-nowrap">
                              {this._measureInfo.archived
                                ? this.getAppContext()
                                    .momentjs(this._measureInfo.archived, "X")
                                    .format("L LT")
                                : "-"}
                            </span>
                          </strong>
                        </div>
                      ) : null}
                      {/* {this.state.data?.smart_notifications &&
                        this.state.data?.smart_notifications == "yes" && ( */}
                      <div
                        className={
                          "d-flex flex-shrink-1 py-1" +
                          (!this.getAppContext().media.isMobile &&
                          !this.getAppContext().media.isTablet
                            ? " px-2"
                            : "")
                        }
                      >
                        {this.state.measure_graph.tags &&
                          this._measureInfo.tags.length > 0 && (
                            <>
                              <strong className="text-muted">TAGS:</strong>
                              <strong className="pl-2">
                                <span className="text-nowrap">
                                  {this._measureInfo.tags
                                    .sort((a, b) =>
                                      a.localeCompare(b, "it", {
                                        sensitivity: "base",
                                      }),
                                    )
                                    .map((tag) => {
                                      return (
                                        <Badge
                                          key={tag}
                                          style={{
                                            fontSize: "14px",
                                            cursor: "pointer",
                                            // color: "#a1a9b0",
                                            fontWeight: "400",
                                          }}
                                          pill
                                          onClick={() =>
                                            this.handleTagClick(tag)
                                          }
                                          className={`border border-1 border-gray700 text-gray800 mr-2 mb-1 bg-white`}
                                        >
                                          <strong>{tag}</strong>
                                        </Badge>
                                      );
                                    })}
                                </span>
                              </strong>
                            </>
                          )}
                      </div>
                      <div className="flex-grow-1 h-100 d-flex align-items-center">
                        <ReactOActionBar padding="0">
                          <LinkContainer
                            to={{
                              pathname:
                                "/" +
                                this.props.match.params.probeuid +
                                "/config/" +
                                this.props.match.params.measureid,
                              state: {
                                prevPath: window.location.pathname,
                                // fromSmart: this.props.location?.state?.mlist,
                              },
                            }}
                            activeClassName=""
                          >
                            <ReactOButton
                              key={1}
                              icon={
                                this.state.conf_set &&
                                this.state.conf_set.measures_conf
                                  ? this.state.conf_set.measures_conf == "SD"
                                    ? "eye-lateral"
                                    : "pencil"
                                  : ""
                              }
                              color="white"
                              title={
                                this.state.conf_set &&
                                this.state.conf_set.measures_conf
                                  ? this.state.conf_set.measures_conf == "SD"
                                    ? "View"
                                    : "Modify"
                                  : ""
                              }
                              size="sm"
                              onClick={() => {}}
                            />
                          </LinkContainer>
                        </ReactOActionBar>
                      </div>
                    </Section>
                  </small>
                </div>
                {(this.getAppContext().isCloud() &&
                  this._view_form &&
                  this._view_form.getEntry("is_preset") == "yes" &&
                  !this._view_form.getEntry("offset") &&
                  this.props.match.params.bssid != "overal") ||
                (this.props.match.params.bssid == "overal" &&
                  this._view_form &&
                  this._view_form.getEntry("is_preset") == "yes" &&
                  !this._view_form.getEntry("offset") &&
                  /ethernet/i.test(this.state.measure_graph.essid)) ? (
                  <small className="text-right text-muted align-self-end">
                    {this.state.measure_graph.diagnostics &&
                    this.state.measure_graph.diagnostics.last_state ? (
                      <span id="_tooltip_info">
                        {this.state.measure_graph.diagnostics.err_step &&
                        this.state.measure_graph.diagnostics.err_step.length >
                          0 &&
                        this.state.measure_graph.diagnostics.term ? (
                          <ReactOTooltip
                            placement="bottom"
                            target="_tooltip_info"
                            text={
                              this.state.measure_graph.diagnostics.term == 2
                                ? "(On previous 4h)"
                                : "(On last period)"
                            }
                          />
                        ) : null}

                        <strong
                          className={
                            this.state.measure_graph.diagnostics.last_state ==
                              "N" ||
                            this.state.measure_graph.diagnostics.last_state ==
                              "U"
                              ? "text-" +
                                this.getAppContext().conf.MLY_STATES_DICTIONARY[
                                  this.state.measure_graph.diagnostics
                                    .last_state
                                ].color
                              : "text-" +
                                this.state.measure_graph.diagnostics.color
                          }
                        >
                          {this.getAppContext().getDiag(
                            this.state.measure_graph.diagnostics.last_state,
                            this.state.measure_graph.diagnostics.consideration,
                          )}{" "}
                          {this.state.measure_graph.diagnostics.err_step &&
                          this.state.measure_graph.diagnostics.err_step.length >
                            0
                            ? this.getAppContext().getErrWording(
                                this.state.measure_graph.diagnostics.err_step,
                              )
                            : null}
                        </strong>
                        <div>
                          since{" "}
                          {this.state.measure_graph.diagnostics.last_state_ts
                            ? this.getAppContext()
                                .momentjs(
                                  this.state.measure_graph.diagnostics
                                    .last_state_ts,
                                  "X",
                                )
                                .format("L LT")
                            : "-"}
                        </div>
                      </span>
                    ) : this.getAppContext().isCloud() ? (
                      <div
                        className={
                          "text-" +
                          this.getAppContext().conf.MLY_STATES_DICTIONARY["NA"]
                            .color
                        }
                      >
                        {
                          this.getAppContext().conf.MLY_STATES_DICTIONARY["NA"]
                            .text
                        }
                      </div>
                    ) : null}
                  </small>
                ) : null}
              </div>
            );
          })()}
        </Section>

        <Section designType="wide" className="mx-4 mb-4">
          <ReactOForm
            submitOnEnterKey={true}
            onControllerReady={(form_controller) => {
              this._view_form = form_controller;
            }}
            onSubmit={(data, submit_cb, opt) => {
              this.getAppContext()
                .getLocalStorageService()
                .set("measure_graph_view", data);

              if (this.dateRangePicker.current) {
                if (data.is_preset == "yes") {
                  let startDate =
                    this.getAppContext().momentjs().unix() - data.view_preset;
                  const startM = this.getAppContext().momentjs(startDate, "X");
                  if (startM.isValid()) {
                    this.dateRangePicker.current.setStartDate(startM);
                  }
                  this.dateRangePicker.current.setEndDate(
                    this.getAppContext().momentjs(),
                  );
                } else {
                  const startM = this.getAppContext().momentjs(data.stime, "X");
                  const endM = this.getAppContext().momentjs(data.etime, "X");
                  if (startM.isValid()) {
                    this.dateRangePicker.current.setStartDate(startM);
                  }
                  if (endM.isValid()) {
                    this.dateRangePicker.current.setEndDate(endM);
                  }
                }
              }
              // console.log("data:: ", data);
              this.loadMeasureGraph(data, submit_cb, opt);
            }}
          >
            <Row noGutters>
              <Col xs={12} sm={8} lg={9}>
                <ReactOFormInput type="hidden" data_key="snapStime" />
                <ReactOFormInput type="hidden" data_key="snapEtime" />
                <ReactOFormInput
                  type="hidden"
                  data_key="stime"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").stime
                      : this.getAppContext().momentjs().unix()
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="etime"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").etime
                      : this.getAppContext().momentjs().unix()
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="offset"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").offset
                      : false
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="is_preset"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").is_preset
                      : "yes"
                  }
                />
                <ReactOFormInput
                  type="hidden"
                  data_key="timeSnapshot"
                  default={
                    this.getAppContext()
                      .getLocalStorageService()
                      .isSet("measure_graph_view")
                      ? this.getAppContext()
                          .getLocalStorageService()
                          .get("measure_graph_view").timeSnapshot
                      : false
                  }
                />

                <ReactOActionBar padding="0" alignV="start">
                  <div className="d-flex align-items-start flex-wrap">
                    <ReactOFormInput
                      type="select"
                      inputClassName="select-w-150"
                      data_key="view_preset"
                      color="primary"
                      noSelectionLabel="Custom preset"
                      default={
                        this.getAppContext()
                          .getLocalStorageService()
                          .isSet("measure_graph_view")
                          ? this.getAppContext()
                              .getLocalStorageService()
                              .get("measure_graph_view").view_preset
                          : 3600 * 4
                      }
                      onOptionSelect={(form_ctrl, selected_value) => {
                        this.setState(
                          {
                            infoMsg: "",
                            isCustom: false,
                            showInputTime: false,
                            invalidCustomRange: false,
                            inputFieldValue: this.state.customYref
                              ? this.parseCustomYref()
                              : this.state.measure_graph.Yref,
                            customYref: this.state.customYref
                              ? this.parseCustomYref()
                              : undefined,
                          },
                          () => {
                            form_ctrl.handleFormChange(
                              "view_preset",
                              selected_value,
                            );
                            form_ctrl.handleFormChange("is_preset", "yes");
                            form_ctrl.handleFormChange("offset", false);
                            form_ctrl.handleFormChange("snapStime", "");
                            form_ctrl.handleFormChange("snapEtime", "");
                            form_ctrl.submit();
                          },
                        );
                      }}
                      options={(form_data) => {
                        return [
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600
                                ? "1 hour"
                                : "Last hour",
                            value: 3600,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 4
                                ? "4 hours"
                                : "Last 4 hours",
                            value: 3600 * 4,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24
                                ? "24 hours"
                                : "Last 24 hours",
                            value: 3600 * 24,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24 * 7
                                ? "7 days"
                                : "Last 7 days",
                            value: 3600 * 24 * 7,
                          },
                          {
                            name:
                              form_data.offset !== undefined &&
                              form_data.offset != 0 &&
                              form_data.view_preset == 3600 * 24 * 7 * 4
                                ? "4 weeks"
                                : "Last 4 weeks",
                            value: 3600 * 24 * 7 * 4,
                          },
                        ];
                      }}
                    />

                    <div className="ml-2">
                      {(() => {
                        let _offset =
                          this._view_form && this._view_form.isInitialized()
                            ? this._view_form.getEntry("offset")
                            : 0;
                        return (
                          <ButtonGroup>
                            <ReactOButton
                              icon="navigate-prev"
                              color={
                                _offset !== undefined && _offset < 0
                                  ? "success"
                                  : "secondary"
                              }
                              outline={_offset === undefined || _offset >= 0}
                              disabled={
                                (this.state.loading &&
                                  !this._IS_AUTO_RELOADING) ||
                                this.state.outOfLimit
                              }
                              onClick={() => {
                                let _offset =
                                  this._view_form.getEntry("offset") || 0;
                                let timeSnapshot = this.getAppContext()
                                  .momentjs()
                                  .unix();
                                let _new_offset =
                                  _offset !== undefined
                                    ? _offset -
                                      this._explorerParameters._range / 2
                                    : this._explorerParameters._range / 2;
                                this._view_form.handleFormChange(
                                  "offset",
                                  _new_offset == 0 ? false : _new_offset,
                                );
                                this._view_form.handleFormChange(
                                  "timeSnapshot",
                                  timeSnapshot,
                                );

                                let stime, etime;
                                if (this._view_form.getEntry("snapStime")) {
                                  stime = this._view_form.getEntry("snapStime");
                                  etime = this._view_form.getEntry("snapEtime");
                                } else {
                                  stime =
                                    this.state.measure_graph.viewRangeData
                                      .stime;
                                  etime =
                                    this.state.measure_graph.viewRangeData
                                      .etime;
                                  this._view_form.handleFormChange(
                                    "snapStime",
                                    stime,
                                  );
                                  this._view_form.handleFormChange(
                                    "snapEtime",
                                    etime,
                                  );
                                }

                                const offsetStime = stime + _new_offset;
                                const offsetEtime = etime + _new_offset;

                                this._view_form.handleFormChange(
                                  "is_preset",
                                  "no",
                                );
                                this._view_form.handleFormChange(
                                  "stime",
                                  offsetStime,
                                );
                                this._view_form.handleFormChange(
                                  "etime",
                                  offsetEtime,
                                );
                                this._view_form.submit();
                              }}
                            />
                            <ReactOButton
                              icon="navigate-next"
                              color={
                                _offset !== undefined && _offset > 0
                                  ? "success"
                                  : "secondary"
                              }
                              outline={_offset === undefined || _offset <= 0}
                              disabled={
                                this.state.loading ||
                                (this.state?.measure_graph?.viewRangeData
                                  ?.etime &&
                                  this.checkFutureTime(
                                    this.state?.measure_graph?.viewRangeData
                                      ?.etime,
                                  ))
                              }
                              onClick={() => {
                                let _offset =
                                  this._view_form.getEntry("offset") || 0;
                                let timeSnapshot = this.getAppContext()
                                  .momentjs()
                                  .unix();
                                let _new_offset =
                                  _offset !== undefined
                                    ? _offset +
                                      this._explorerParameters._range / 2
                                    : this._explorerParameters._range / 2;
                                this._view_form.handleFormChange(
                                  "offset",
                                  _new_offset == 0
                                    ? false
                                    : Math.round(_new_offset),
                                );
                                this._view_form.handleFormChange(
                                  "timeSnapshot",
                                  timeSnapshot,
                                );

                                let stime, etime;
                                if (this._view_form.getEntry("snapStime")) {
                                  stime = this._view_form.getEntry("snapStime");
                                  etime = this._view_form.getEntry("snapEtime");
                                } else {
                                  stime =
                                    this.state.measure_graph.viewRangeData
                                      .stime;
                                  etime =
                                    this.state.measure_graph.viewRangeData
                                      .etime;
                                  this._view_form.handleFormChange(
                                    "snapStime",
                                    stime,
                                  );
                                  this._view_form.handleFormChange(
                                    "snapEtime",
                                    etime,
                                  );
                                }

                                const offsetStime = stime + _new_offset;
                                const offsetEtime = etime + _new_offset;

                                this._view_form.handleFormChange(
                                  "is_preset",
                                  "no",
                                );
                                this._view_form.handleFormChange(
                                  "stime",
                                  offsetStime,
                                );
                                this._view_form.handleFormChange(
                                  "etime",
                                  offsetEtime,
                                );
                                this._view_form.submit();
                              }}
                            />
                          </ButtonGroup>
                        );
                      })()}
                    </div>

                    <span className="ml-2">
                      {(() => {
                        const cached = this.getAppContext()
                          .getLocalStorageService()
                          .isSet("measure_graph_view")
                          ? this.getAppContext()
                              .getLocalStorageService()
                              .get("measure_graph_view")
                          : null;
                        const formReady =
                          this._view_form && this._view_form.isInitialized();
                        const isCustom = formReady
                          ? this._view_form.getEntry("is_preset") == "no"
                          : cached && cached.is_preset == "no";
                        const stime = formReady
                          ? this._view_form.getEntry("stime")
                          : cached && cached.stime;
                        const etime = formReady
                          ? this._view_form.getEntry("etime")
                          : cached && cached.etime;
                        const startMoment =
                          isCustom && stime
                            ? this.getAppContext().momentjs(stime, "X")
                            : this.getAppContext().momentjs();
                        const endMoment =
                          isCustom && etime
                            ? this.getAppContext().momentjs(etime, "X")
                            : this.getAppContext().momentjs();
                        return (
                          <DateRangePicker
                            initialSettings={{
                              startDate: startMoment.isValid()
                                ? startMoment
                                : this.getAppContext().momentjs(),
                              endDate: endMoment.isValid()
                                ? endMoment
                                : this.getAppContext().momentjs(),
                              autoApply: true,
                              minDate:
                                this.getAppContext().handleTSLimit().dateParsed,
                              maxDate: this.getAppContext()
                                .momentjs()
                                .startOf("day")
                                .toDate(),
                            }}
                            ref={this.dateRangePicker}
                            onApply={(_e, picker) => {
                              let startDate = picker.startDate.unix();
                              let endDate = picker.endDate.unix() + 1;

                              this.setState(
                                {
                                  showInputTime: false,
                                  invalidCustomRange: false,
                                  inputFieldValue: this.state.customYref
                                    ? this.parseCustomYref()
                                    : this.state.measure_graph.Yref,
                                  customYref: this.state.customYref
                                    ? this.parseCustomYref()
                                    : undefined,
                                },
                                () => {
                                  this._view_form.handleFormChange(
                                    "is_preset",
                                    "no",
                                  );
                                  this._view_form.handleFormChange(
                                    "view_preset",
                                    "no",
                                  );
                                  this._view_form.handleFormChange(
                                    "offset",
                                    false,
                                  );
                                  this._view_form.handleFormChange(
                                    "stime",
                                    startDate,
                                  );
                                  this._view_form.handleFormChange(
                                    "etime",
                                    endDate,
                                  );
                                  this._view_form.submit();
                                },
                              );
                            }}
                          >
                            <button
                              id="_tp_drp"
                              disabled={
                                this.state.loading && !this._IS_AUTO_RELOADING
                              }
                              className="selected-date-range-btn text-nowrap nofocus btn btn-outline-secondary mr-2"
                            >
                              <span className="icon-calendar" />
                            </button>
                          </DateRangePicker>
                        );
                      })()}
                    </span>
                    <ReactOTooltip
                      placement="top"
                      delay={{ show: 200 }}
                      target="_tp_drp"
                      text={
                        "Oldest measure data: " +
                        this.getAppContext()
                          .momentjs(
                            this.getAppContext().handleTSLimit().limit,
                            "X",
                          )
                          .format("L LT")
                      }
                    />

                    <button
                      disabled={this.state.loading && !this._IS_AUTO_RELOADING}
                      style={
                        this.state.showInputTime ? { display: "none" } : {}
                      }
                      className="selected-date-range-btn text-nowrap nofocus btn btn-outline-secondary"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState(
                          {
                            showInputTime: true,
                          },
                          () => {
                            this.setState({ range: this.parseTime() });
                          },
                        );
                      }}
                    >
                      <span style={{ marginRight: "8px" }} />
                      {this.parseTime()}
                    </button>

                    {this.state.showInputTime == true ? (
                      <span>
                        <Input
                          className="width-input form-control custom-input-header-modal"
                          bsSize="xs"
                          value={this.handleCustomRange()}
                          autoFocus
                          type="text"
                          invalid={this.state.invalidCustomRange}
                          disabled={this.state.loading}
                          onKeyDown={(e) => {
                            if (
                              e.key == "Enter" &&
                              !this.state.invalidCustomRange
                            ) {
                              e.preventDefault();
                              if (this.state.customYref) {
                                this.setState(
                                  {
                                    inputFieldValue: this.parseCustomYref(),
                                    customYref: this.parseCustomYref(),
                                  },
                                  () => {
                                    this.submitCustomRange();
                                  },
                                );
                              } else {
                                this.submitCustomRange();
                              }
                            } else if (
                              e.key == "Enter" &&
                              this.state.invalidCustomRange
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (this._AUTO_RELOAD_TIMEOUT) {
                              clearTimeout(this._AUTO_RELOAD_TIMEOUT);
                            }
                            if (this.checkStartDateLoop) {
                              clearTimeout(this.checkStartDateLoop);
                            }
                            e.preventDefault();
                            let string = e.target.value;
                            this.setState({
                              invalidCustomRange: false,
                              isCustom: true,
                              range: string,
                            });
                          }}
                        />
                        <FormFeedback>
                          {this.state.invalidCustomRangeMsg}
                        </FormFeedback>
                        {!this.state.invalidCustomRangeMsg && (
                          <FormText
                            color="muted"
                            className="d-flex align-items-start"
                          >
                            <span
                              className="icon-info mr-1"
                              style={{ fontSize: "120%" }}
                            />
                            Press "Enter" to submit
                          </FormText>
                        )}
                      </span>
                    ) : (
                      <span />
                    )}

                    {this._view_form &&
                    this._view_form.isInitialized() &&
                    this._view_form.getEntry("offset") !== undefined ? (
                      <ButtonGroup className="ml-2">
                        <ReactOButton
                          icon="close-outline"
                          disabled={
                            this.state.loading && !this._IS_AUTO_RELOADING
                          }
                          onClick={() => {
                            this._view_form.handleFormChange("offset", false);
                            const snapStime = parseInt(
                              this._view_form.getEntry("snapStime"),
                            );
                            const snapEtime = parseInt(
                              this._view_form.getEntry("snapEtime"),
                            );
                            this._view_form.handleFormChange(
                              "stime",
                              snapStime - (snapStime % 60),
                            );
                            this._view_form.handleFormChange(
                              "etime",
                              snapEtime - (snapEtime % 60),
                            );
                            this._view_form.submit();
                          }}
                        />
                      </ButtonGroup>
                    ) : null}
                  </div>
                </ReactOActionBar>
              </Col>
              <Col
                sm={4}
                lg={3}
                className={
                  this.state.showInputTime
                    ? "mb-4 pb-1 align-self-end text-right mt-3 mt-lg-0"
                    : "align-self-end text-right mt-3 mt-lg-0"
                }
              >
                {this.props.match.params.status == "active" ? (
                  <div className="sub-title">
                    Most recent measure at:{" "}
                    <strong className="text-nowrap">
                      {this.state.measure_graph.last_update
                        ? this.getAppContext()
                            .momentjs(this.state.measure_graph.last_update, "X")
                            .format("L LT")
                        : "-"}
                    </strong>
                  </div>
                ) : null}
              </Col>
            </Row>
          </ReactOForm>
        </Section>

        <Section designType="wide" className="mx-4 mb-4">
          <Panel padding="0" rounded>
            <_LoadingWrapper
              minHeight
              loadingPlug={
                (this.state.loading && !this._IS_AUTO_RELOADING) ||
                this.state.loading_notes
              }
            >
              {this.state.measure_graph.graphData ? (
                <div>
                  <div
                    className="mx-auto mb-2"
                    style={{
                      maxWidth:
                        this.state.measure_graph.graphData.ImgExtW + "px",
                    }}
                  >
                    <div className="d-flex">
                      <div className="mr-auto">
                        <small className="text-muted mr-auto">seconds</small>
                        <span>
                          <small className="text-muted ml-4 mr-2">
                            Y scale:
                          </small>
                        </span>
                        <span>
                          <Input
                            className="form-control input-header-modal"
                            bsSize="xs"
                            // defaultValue={this.state.measure_graph.Yref}
                            value={this.handleValue()}
                            type="text"
                            placeholder="Seconds"
                            invalid={this.state.invalidYref}
                            disabled={this.state.loading}
                            onChange={(e) => {
                              let string = e.target.value;
                              this.setState({
                                inputFieldValue: string,
                                startSpin: true,
                              });

                              if (
                                string == "" ||
                                this.checkValidYref(string) ||
                                string == "MAX" ||
                                string == "AVG2"
                              ) {
                                this.setState({ invalidYref: false });
                                // delay
                                this.globalTime = Date.now();
                                let singleTime = Date.now();
                                setTimeout(() => {
                                  this.delayForm(singleTime, string);
                                }, 800);
                              } else {
                                this.setState({ invalidYref: true });
                              }
                            }}
                          />
                          {this.state.startSpin &&
                          this.state.invalidYref == false ? (
                            <span className="valid-spin">
                              <ClipLoader
                                color={this.getAppContext().colors.primary}
                                size={15}
                                margin="5px"
                              />
                            </span>
                          ) : null}
                        </span>
                        <span>
                          <span
                            id="yref_tooltip"
                            className="sub-title icon-info ml-2 align-middle"
                            style={{ fontSize: "120%" }}
                          />
                          <ReactOTooltip
                            placement="right"
                            target="yref_tooltip"
                            text={
                              <div className="text-left">
                                <span className="mb-1">Type:</span>
                                <br />
                                - a number <br />
                                - MAX: set Ymax to the highest measure
                                <br />
                                - AVG2: set Ymax to twice TOTAL AVG TIME
                                <br />
                              </div>
                            }
                          />
                        </span>
                      </div>

                      <div>
                        <strong>{this.state.infoMsg}</strong>
                      </div>

                      <div className="ml-auto">
                        <ReactOButton
                          size="sm"
                          color="secondary"
                          outline
                          onClick={(e) => {
                            this._notes_editing_ctrl.openListModal();
                          }}
                        >
                          <span className="icon-note mr-2" />
                          Notes
                        </ReactOButton>
                      </div>
                    </div>
                  </div>
                  <div
                    id="graph-explorer-container"
                    className="graph-explorer-container mx-auto"
                    style={{
                      maxWidth:
                        this.state.measure_graph.graphData.ImgExtW + "px",
                    }}
                  >
                    <div className="graph-explorer-content">
                      <img
                        src={
                          this.getAppContext()
                            .getApiStoreService()
                            .getCluster() +
                          "/RRDgrcache/" +
                          this.state.measure_graph.graphData.ImgName
                        }
                        alt="chart"
                        onLoad={() => this.stopLoadingIMG()}
                      />
                    </div>
                    <div className="graph-explorer-overlay-container">
                      <div
                        className="graph-explorer-tickers-container"
                        style={{
                          top: "3.36%",
                          bottom: "6.71%",
                          left: "5.19%",
                          right: "2.5%",
                        }}
                        onMouseLeave={() => {
                          if (!this.getAppContext().media.isMobile) {
                            this.unsetActivePopup();
                          }
                        }}
                      >
                        {(() => {
                          this._explorerParameters = {
                            _range:
                              this.state.measure_graph.viewRangeData.etime -
                              this.state.measure_graph.viewRangeData.stime,
                            _ticks_list: [],
                            _notes: [],
                          };

                          // Mostra popup con dettagli
                          if (
                            this._explorerParameters._range <= 3600 ||
                            (this._explorerParameters._range <= 3600 * 4 &&
                              !this.getAppContext().media.isMobile)
                          ) {
                            this._explorerParameters._divider =
                              this.state.measure_graph.graphData.rrd_step;
                            this._explorerParameters._must_zoom = false;
                          } else if (
                            this._explorerParameters._range == 3600 * 4 &&
                            this.getAppContext().media.isMobile
                          ) {
                            // Mostra tick di zoom
                            this._explorerParameters._divider = 3600;
                            this._explorerParameters._must_zoom = true;
                          } else if (
                            this._explorerParameters._range ==
                            3600 * 24
                          ) {
                            if (this.getAppContext().media.isMobile) {
                              this._explorerParameters._divider = 3600 * 4;
                              this._explorerParameters.span = 3600 * 4;
                              this._explorerParameters._must_zoom = true;
                            } else {
                              this._explorerParameters._divider = 4800;
                              this._explorerParameters.span = 3600 * 4;
                              this._explorerParameters._must_zoom = true;
                            }
                          } else if (
                            this._explorerParameters._range ==
                            3600 * 24 * 7
                          ) {
                            this._explorerParameters._divider = 28800;
                            this._explorerParameters.span = 3600 * 24;
                            this._explorerParameters._must_zoom = true;
                          } else if (
                            this._explorerParameters._range ==
                            3600 * 24 * 7 * 4
                          ) {
                            this._explorerParameters._divider = 201600;
                            this._explorerParameters.span = 3600 * 24 * 7;
                            this._explorerParameters._must_zoom = true;
                          } else if (
                            this._explorerParameters._range % 86400 == 0 ||
                            (this._explorerParameters._range % 86400 != 0 &&
                              this._explorerParameters._range > 86400)
                          ) {
                            this._explorerParameters._divider = 28800;
                            this._explorerParameters.span = 3600 * 24;
                            this._explorerParameters._must_zoom = true;
                          } else {
                            this._explorerParameters._divider = 4800;
                            this._explorerParameters.span = 3600 * 4;
                            this._explorerParameters._must_zoom = true;
                          }

                          this._explorerParameters._tick_width =
                            100 /
                            ((this.state.measure_graph.viewRangeData.etime -
                              this.state.measure_graph.viewRangeData.stime) /
                              this._explorerParameters._divider);
                          this._explorerParameters._tickFirst_width =
                            this._explorerParameters._tick_width -
                            (this.state.measure_graph.viewRangeData.stime %
                              this.state.measure_graph.graphData.rrd_step >
                            0
                              ? 100 /
                                ((this.state.measure_graph.viewRangeData.etime -
                                  this.state.measure_graph.viewRangeData
                                    .stime) /
                                  (this.state.measure_graph.viewRangeData
                                    .stime %
                                    this.state.measure_graph.graphData
                                      .rrd_step))
                              : 0);
                          this._explorerParameters._tickLast_width =
                            this.state.measure_graph.viewRangeData.stime %
                              this.state.measure_graph.graphData.rrd_step >
                            0
                              ? 100 /
                                ((this.state.measure_graph.viewRangeData.etime -
                                  this.state.measure_graph.viewRangeData
                                    .stime) /
                                  (this.state.measure_graph.viewRangeData
                                    .stime %
                                    this.state.measure_graph.graphData
                                      .rrd_step))
                              : 0;

                          for (
                            let n =
                              !this._explorerParameters._must_zoom &&
                              this.state.measure_graph.graphData.rrd_step > 60
                                ? this.state.measure_graph.viewRangeData.stime -
                                  (this.state.measure_graph.viewRangeData
                                    .stime %
                                    this.state.measure_graph.graphData.rrd_step)
                                : this.state.measure_graph.viewRangeData.stime;
                            !this._explorerParameters._must_zoom &&
                            this.state.measure_graph.graphData.rrd_step > 60
                              ? n <=
                                this.state.measure_graph.viewRangeData.etime
                              : n <
                                this.state.measure_graph.viewRangeData.etime;
                            n += this._explorerParameters._divider
                          ) {
                            this._explorerParameters._ticks_list.push(n);
                          }

                          this._explorerParameters._notes = (
                            this.state.measure_graph.notes || []
                          ).filter((value) => {
                            return (
                              value.ts >=
                                this.state.measure_graph.viewRangeData.stime &&
                              value.ts <
                                this.state.measure_graph.viewRangeData.etime
                            );
                          });

                          return this._explorerParameters._ticks_list.map(
                            (_CURR_tick, _CURR_idx, array) => {
                              let _TMP_tick_notes =
                                this._explorerParameters._notes.filter(
                                  (value) => {
                                    return (
                                      value.ts >= _CURR_tick &&
                                      value.ts <
                                        _CURR_tick +
                                          this._explorerParameters._divider
                                    );
                                  },
                                );

                              let _TMP_left = 0;
                              let _TMP_width = 0;
                              if (this._explorerParameters._must_zoom) {
                                // IF LAST IDX, set last width for personal timing
                                // console.log("_tick_width standard", _tick_width);
                                _TMP_left =
                                  this._explorerParameters._tick_width *
                                  _CURR_idx;

                                if (
                                  // this.state.range &&
                                  _CURR_idx ==
                                  array.length - 1
                                ) {
                                  // console.log("is custom", this.state.range);
                                  _TMP_width = 100 - _TMP_left;
                                } else {
                                  _TMP_width =
                                    this._explorerParameters._tick_width;
                                }
                              } else {
                                _TMP_left =
                                  this._explorerParameters._tick_width *
                                    _CURR_idx -
                                  (this.state.measure_graph.graphData.rrd_step >
                                    60 && _CURR_idx > 0
                                    ? this._explorerParameters._tickLast_width
                                    : 0);
                                _TMP_width =
                                  this.state.measure_graph.graphData.rrd_step >
                                  60
                                    ? _CURR_idx == 0
                                      ? this._explorerParameters
                                          ._tickFirst_width
                                      : _CURR_idx ==
                                          this._explorerParameters._ticks_list
                                            .length -
                                            1
                                        ? this._explorerParameters
                                            ._tickLast_width
                                        : this._explorerParameters._tick_width
                                    : this._explorerParameters._tick_width;
                              }

                              let _overZoomTick = () => {
                                let twin = [];
                                let ts;
                                let ts_end;
                                let span = !this.getAppContext().media.isMobile
                                  ? this._explorerParameters.span
                                  : this._explorerParameters._divider;

                                // let tick_x;
                                if (_CURR_idx == 0) {
                                  !this.getAppContext().media.isMobile &&
                                    twin.push(
                                      array[_CURR_idx + 1],
                                      array[_CURR_idx + 2],
                                    );
                                  ts = _CURR_tick;
                                  ts_end = _CURR_tick + span;

                                  // tick_x =
                                  //   this._explorerParameters._tick_width *
                                  //   (_CURR_idx + 2);
                                } else if (_CURR_idx == 1) {
                                  !this.getAppContext().media.isMobile &&
                                    twin.push(
                                      array[_CURR_idx - 1],
                                      array[_CURR_idx + 1],
                                    );
                                  ts = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 1]
                                    : _CURR_tick;
                                  ts_end = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 1] + span
                                    : _CURR_tick + span;
                                  // tick_x =
                                  //   this._explorerParameters._tick_width * _CURR_idx + 6;
                                } else if (_CURR_idx == array.length - 1) {
                                  !this.getAppContext().media.isMobile &&
                                    twin.push(
                                      array[_CURR_idx - 1],
                                      array[_CURR_idx - 2],
                                    );
                                  ts = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 2]
                                    : _CURR_tick;
                                  ts_end = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 2] + span
                                    : _CURR_tick + span;
                                  // tick_x =
                                  //   this._explorerParameters._tick_width *
                                  //   (_CURR_idx - 1);
                                } else if (_CURR_idx == array.length - 2) {
                                  !this.getAppContext().media.isMobile &&
                                    twin.push(
                                      array[_CURR_idx - 1],
                                      array[_CURR_idx + 1],
                                    );
                                  ts = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 1]
                                    : _CURR_tick;
                                  ts_end = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 1] + span
                                    : _CURR_tick + span;
                                  // tick_x =
                                  //   this._explorerParameters._tick_width *
                                  //   (_CURR_idx - 2);
                                } else {
                                  !this.getAppContext().media.isMobile &&
                                    twin.push(
                                      array[_CURR_idx - 1],
                                      array[_CURR_idx + 1],
                                    );
                                  ts = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 1]
                                    : _CURR_tick;
                                  ts_end = !this.getAppContext().media.isMobile
                                    ? array[_CURR_idx - 1] + span
                                    : _CURR_tick + span;
                                  // tick_x =
                                  //   this._explorerParameters._tick_width *
                                  //   (_CURR_idx - 1);
                                }

                                this.setActivePopup({
                                  hovered: _CURR_tick,
                                  ts: ts,
                                  twin: twin,
                                  // ts_end,
                                  ts_end:
                                    this.state.isCustom &&
                                    _CURR_idx == array.length - 1
                                      ? this.getAppContext()
                                          .getLocalStorageService()
                                          .get("measure_graph_view").etime
                                      : ts_end,
                                  tick_x:
                                    this._explorerParameters._tick_width *
                                    _CURR_idx,
                                  tick_width:
                                    this._explorerParameters._tick_width,
                                  _is_zoom: true,
                                });
                              };

                              let _clickZoomTick = () => {
                                this.setState({ showInputTime: false }, () => {
                                  this._view_form.handleFormChange(
                                    "is_preset",
                                    "no",
                                  );
                                  this._view_form.handleFormChange(
                                    "view_preset",
                                    "no",
                                  );
                                  this._view_form.handleFormChange(
                                    "offset",
                                    false,
                                  );
                                  this._view_form.handleFormChange(
                                    "stime",
                                    this.state._activePopup.ts,
                                  );
                                  if (
                                    this.getAppContext()
                                      .getLocalStorageService()
                                      .get("measure_graph_view") &&
                                    this.getAppContext()
                                      .getLocalStorageService()
                                      .get("measure_graph_view").range &&
                                    _CURR_idx == array.length - 1
                                  ) {
                                    this._view_form.handleFormChange(
                                      "etime",
                                      this.getAppContext()
                                        .getLocalStorageService()
                                        .get("measure_graph_view").etime,
                                    );
                                  } else {
                                    this._view_form.handleFormChange(
                                      "etime",
                                      this.state._activePopup.ts_end,
                                    );
                                  }

                                  this._view_form.submit();
                                });
                              };

                              let _overDataTick = () => {
                                this.setActivePopup({
                                  ts: _CURR_tick,
                                  ts_end:
                                    _CURR_tick +
                                    this._explorerParameters._divider,
                                  retention_ts_range:
                                    this.state.measure_graph.graphData
                                      .rrd_step > 60
                                      ? {
                                          ts:
                                            _CURR_tick -
                                            this.state.measure_graph.graphData
                                              .rrd_step /
                                              2,
                                          ts_end:
                                            _CURR_tick -
                                            this.state.measure_graph.graphData
                                              .rrd_step /
                                              2 +
                                            this._explorerParameters._divider,
                                        }
                                      : undefined,
                                  tick_x:
                                    this._explorerParameters._tick_width *
                                      _CURR_idx -
                                    (this.state.measure_graph.graphData
                                      .rrd_step > 60 && _CURR_idx > 0
                                      ? this._explorerParameters._tickLast_width
                                      : 0),
                                  tick_width:
                                    this.state.measure_graph.graphData
                                      .rrd_step > 60
                                      ? _CURR_idx == 0
                                        ? this._explorerParameters
                                            ._tickFirst_width
                                        : _CURR_idx ==
                                            this._explorerParameters._ticks_list
                                              .length -
                                              1
                                          ? this._explorerParameters
                                              ._tickLast_width
                                          : this._explorerParameters._tick_width
                                      : this._explorerParameters._tick_width,
                                  _is_zoom: false,
                                });
                              };

                              let _clickDataTick = (e) => {
                                if (e.shiftKey) {
                                  this._notes_editing_ctrl.createNoteAt(
                                    _CURR_tick,
                                  );
                                } else if (e.metaKey) {
                                  window.open(
                                    "/web/" +
                                      this.props.match.params.probeuid +
                                      "/" +
                                      this.props.match.params.status +
                                      "/" +
                                      this.props.match.params.measureid +
                                      "/" +
                                      this.props.match.params.bssid +
                                      "/results/" +
                                      _CURR_tick +
                                      "/i",
                                    "_blank",
                                  );
                                } else {
                                  this.getAppContext().redirectTo(
                                    "/" +
                                      this.props.match.params.probeuid +
                                      "/" +
                                      this.props.match.params.status +
                                      "/" +
                                      this.props.match.params.measureid +
                                      "/" +
                                      this.props.match.params.bssid +
                                      "/results/" +
                                      _CURR_tick +
                                      "/i",
                                  );
                                }
                              };

                              return this._explorerParameters._must_zoom ? (
                                <div
                                  id={"_ID_tick_zoom_" + _CURR_idx}
                                  key={_CURR_idx}
                                  // className={
                                  //   "graph-explorer-tick zoom-tick" +
                                  //   (this.state._activePopup &&
                                  //   this.state._activePopup.ts == _CURR_tick
                                  //     ? " active"
                                  //     : "")
                                  // }
                                  className={
                                    "graph-explorer-tick zoom-tick" +
                                    (this.state._activePopup &&
                                    (this.state._activePopup.hovered ==
                                      _CURR_tick ||
                                      this.state._activePopup?.twin?.includes(
                                        _CURR_tick,
                                      ))
                                      ? " active"
                                      : "")
                                  }
                                  style={{
                                    cursor: "pointer",
                                    left: _TMP_left + "%",
                                    width: _TMP_width + "%",
                                  }}
                                  onMouseOver={() => {
                                    _overZoomTick();
                                  }}
                                  onClick={() => {
                                    if (this.getAppContext().media.isMobile) {
                                      _overZoomTick();
                                    } else {
                                      _clickZoomTick();
                                    }
                                  }}
                                >
                                  {_TMP_tick_notes.length ? (
                                    <ReactOTooltip
                                      container="#graph-explorer-container"
                                      keepOpen
                                      light
                                      system={
                                        _TMP_tick_notes.length == 1 &&
                                        _TMP_tick_notes[0].type == "system"
                                      }
                                      key={_CURR_idx + ".1"}
                                      placement="top"
                                      target={"_ID_tick_zoom_" + _CURR_idx}
                                      text={
                                        <div>
                                          <span className="icon-note mr-2" />
                                          {_TMP_tick_notes.length} note
                                          {_TMP_tick_notes.length > 1
                                            ? "s"
                                            : ""}
                                        </div>
                                      }
                                    />
                                  ) : null}
                                </div>
                              ) : (
                                <div
                                  id={"_ID_tick_" + _CURR_idx}
                                  key={_CURR_idx + ".2"}
                                  //href={'/' + this.props.match.params.probeuid + '/' + this.props.match.params.status + '/' + this.props.match.params.measureid + '/' + this.props.match.params.bssid + '/results/' + (_CURR_tick) + '/i'}
                                  className={
                                    "graph-explorer-tick" +
                                    (this.state._activePopup &&
                                    this.state._activePopup.ts == _CURR_tick
                                      ? " active"
                                      : "") +
                                    (_TMP_tick_notes.length
                                      ? " bg-gray500"
                                      : "")
                                  }
                                  style={{
                                    cursor: !this.getAppContext().handleTSLimit(
                                      _CURR_tick,
                                    ).outOfLimit
                                      ? "pointer"
                                      : "",
                                    left:
                                      this._explorerParameters._tick_width *
                                        _CURR_idx -
                                      (this.state.measure_graph.graphData
                                        .rrd_step > 60 && _CURR_idx > 0
                                        ? this._explorerParameters
                                            ._tickLast_width
                                        : 0) +
                                      "%",
                                    width:
                                      array.length == 1
                                        ? "100%"
                                        : (this.state.measure_graph.graphData
                                            .rrd_step > 60
                                            ? _CURR_idx == 0
                                              ? this._explorerParameters
                                                  ._tickFirst_width
                                              : _CURR_idx ==
                                                  this._explorerParameters
                                                    ._ticks_list.length -
                                                    1
                                                ? this._explorerParameters
                                                    ._tickLast_width
                                                : this._explorerParameters
                                                    ._tick_width
                                            : this._explorerParameters
                                                ._tick_width) + "%",
                                  }}
                                  onMouseOver={() => {
                                    _overDataTick();
                                  }}
                                  onClick={(e) => {
                                    if (
                                      !this.getAppContext().handleTSLimit(
                                        _CURR_tick,
                                      ).outOfLimit
                                    ) {
                                      if (this.getAppContext().media.isMobile) {
                                        _overDataTick();
                                      } else {
                                        _clickDataTick(e);
                                      }
                                    }
                                  }}
                                >
                                  {_TMP_tick_notes.length ? (
                                    <ReactOTooltip
                                      container="#graph-explorer-container"
                                      keepOpen
                                      light
                                      system={
                                        _TMP_tick_notes.length == 1 &&
                                        _TMP_tick_notes[0].type == "system"
                                      }
                                      key={_CURR_idx + ".1"}
                                      placement="top"
                                      target={"_ID_tick_" + _CURR_idx}
                                      text={
                                        <div>
                                          <span className="icon-note mr-2" />
                                          {_TMP_tick_notes.length} note
                                          {_TMP_tick_notes.length > 1
                                            ? "s"
                                            : ""}
                                        </div>
                                      }
                                    />
                                  ) : null}
                                </div>
                              );
                            },
                          );
                        })()}
                        {!this.getAppContext().media.isMobile &&
                        this.state._activePopup ? (
                          <div
                            className={
                              "graph-explorer-overlay-popup" +
                              (this.state._activePopup.tick_x >= 50
                                ? " mr-2"
                                : " ml-2")
                            }
                            style={{
                              top: 0,
                              ...(this.state._activePopup.tick_x >= 50
                                ? {
                                    right:
                                      100 -
                                      this.state._activePopup.tick_x +
                                      "%",
                                  }
                                : {
                                    left:
                                      this.state._activePopup.tick_x +
                                      this.state._activePopup.tick_width +
                                      "%",
                                  }),
                            }}
                          >
                            {_popup("overlay")}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {this.getAppContext().media.isMobile ? (
                    <div
                      className={"graph-explorer-popup"}
                      style={{
                        marginLeft: "5.19%",
                        marginRight: "2.5%",
                        top: 0,
                        ...(this.state._activePopup
                          ? this.state._activePopup.tick_x >= 50
                            ? {
                                right:
                                  100 - this.state._activePopup.tick_x + "%",
                              }
                            : {
                                left:
                                  this.state._activePopup.tick_x +
                                  this.state._activePopup.tick_width +
                                  "%",
                              }
                          : {}),
                      }}
                    >
                      {_popup("static")}
                    </div>
                  ) : null}
                  <div
                    className="mx-auto mt-2 d-flex"
                    style={{
                      maxWidth:
                        this.state.measure_graph.graphData.ImgIntW + "px",
                    }}
                  >
                    <Section
                      className="flex-grow-1"
                      designType="wide"
                      layoutManager="grid"
                      elementsPerRow={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet ||
                        this.getAppContext().media.isDesktop
                          ? 2
                          : 6
                      }
                      gridSpacing={5}
                      style={{
                        fontSize: this.getAppContext().media.isMobile
                          ? "0.8rem"
                          : "inherit",
                      }}
                    >
                      {this.state.measure_graph.essid != "Ethernet" ? (
                        <div className="mr-3">
                          <div
                            style={{
                              float: "left",
                              width: "7px",
                              height: "10px",
                              border: "1px solid #de514e",
                              borderWidth: "0 1px 1px 0",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              width: "7px",
                              height: "21px",
                              border: "1px solid #de514e",
                              borderWidth: "1px 1px 0 0",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              marginRight: "7px",
                              width: "7px",
                              height: "10px",
                              marginTop: "11px",
                              border: "1px solid #de514e",
                              borderWidth: "0 1px 1px 0",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              color: "#444",
                              textAlign: "left",
                            }}
                          >
                            RSSI dBm{" "}
                            {this.props.match.params.bssid &&
                              this.props.match.params.bssid == "overal" &&
                              "(avg)"}
                          </div>
                        </div>
                      ) : null}
                      {this.state.measure_graph.essid != "Ethernet" ? (
                        <div
                          className={
                            this.props.match.params.bssid &&
                            this.props.match.params.bssid == "overal"
                              ? "mr-2"
                              : "mr-3"
                          }
                        >
                          <div
                            style={{
                              float: "left",
                              width: "7px",
                              height: "10px",
                              border: "1px solid #FFA559",
                              borderWidth: "0 1px 1px 0",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              width: "7px",
                              height: "21px",
                              border: "1px solid #FFA559",
                              borderWidth: "1px 1px 0 0",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              marginRight: "6px",
                              width: "7px",
                              height: "10px",
                              marginTop: "11px",
                              border: "1px solid #FFA559",
                              borderWidth: "0 1px 1px 0",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              color: "#444",
                              textAlign: "left",
                            }}
                          >
                            Overlap Index{" "}
                            {this.props.match.params.bssid &&
                              this.props.match.params.bssid == "overal" &&
                              "(avg)"}
                          </div>
                        </div>
                      ) : null}
                      <div className="ml-1 mr-3">
                        <div
                          style={{
                            float: "left",
                            marginTop: "5px",
                            width: "7px",
                            height: "16px",
                          }}
                        ></div>
                        <div
                          style={{
                            float: "left",
                            width: "7px",
                            height: "21px",
                            backgroundColor: "#E85129",
                          }}
                        ></div>
                        <div
                          style={{
                            float: "left",
                            marginRight: "7px",
                            marginTop: "5px",
                            width: "7px",
                            height: "16px",
                            backgroundColor: "#ffc107",
                          }}
                        ></div>
                        <div
                          style={{
                            float: "left",
                            color: "#444",
                            textAlign: "left",
                          }}
                        >
                          Errors
                        </div>
                      </div>
                      <div className="mr-3">
                        <div
                          style={{
                            float: "left",
                            marginTop: "5px",
                            width: "14px",
                            height: "16px",
                          }}
                        ></div>
                        <div
                          style={{
                            float: "left",
                            marginRight: "7px",
                            width: "7px",
                            height: "21px",
                            backgroundColor: "#ea8468",
                          }}
                        ></div>
                        <div
                          style={{
                            float: "left",
                            color: "#444",
                            textAlign: "left",
                          }}
                        >
                          Not visible
                        </div>
                      </div>
                      {this.state.measure_graph.essid != "Ethernet" ? (
                        <div className="mr-3">
                          <div
                            style={{
                              float: "left",
                              marginTop: "5px",
                              width: "14px",
                              height: "16px",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              marginRight: "7px",
                              width: "7px",
                              height: "21px",
                              backgroundColor: "#E5E5E5",
                            }}
                          ></div>
                          <div
                            style={{
                              float: "left",
                              color: "#444",
                              textAlign: "left",
                            }}
                          >
                            Out of scope
                          </div>
                        </div>
                      ) : null}
                      <div className="mr-3 mr-auto">
                        <div
                          style={{
                            float: "left",
                            marginTop: "5px",
                            width: "14px",
                            height: "16px",
                          }}
                        ></div>
                        <div style={{ float: "left" }}>
                          <div
                            style={{
                              marginRight: "7px",
                              width: "7px",
                              height: "11px",
                              backgroundColor: "#CCCCCC",
                            }}
                          ></div>
                          <div
                            style={{
                              marginRight: "7px",
                              width: "7px",
                              height: "10px",
                              backgroundColor: "#0774F2",
                            }}
                          ></div>
                        </div>
                        <div
                          style={{
                            float: "left",
                            color: "#444",
                            textAlign: "left",
                          }}
                        >
                          &gt; {this.state.measure_graph.Yref || 10} sec.
                        </div>
                      </div>
                    </Section>
                    {this.getAppContext().isCloud() && (
                      <div id="csv_tooltip_m">
                        <ReactOButton
                          size="sm"
                          color="secondary"
                          icon="download"
                          outline
                          disabled={
                            (this.state.loading && !this._IS_AUTO_RELOADING) ||
                            this.state.loading_csv ||
                            (this.state.measure_graph &&
                              this.state.measure_graph.graphData &&
                              this.state.measure_graph.graphData
                                .measures_count &&
                              this.state.measure_graph.graphData
                                .measures_count == 0) ||
                            (this.state.measure_graph &&
                              this.state.measure_graph.graphData &&
                              !this.state.measure_graph.graphData
                                .measures_count)
                          }
                          onClick={() => {
                            let bssid =
                              this.props.match.params.bssid == "overal"
                                ? "ffffffffffff"
                                : this.props.match.params.bssid;
                            let csv =
                              this.props.match.params.measureid +
                              "@" +
                              bssid +
                              "@" +
                              this.state.measure_graph.test +
                              "_" +
                              this.state.measure_graph.viewRangeData.etime +
                              "_" +
                              this.state.measure_graph.viewRangeData.stime +
                              "_" +
                              this.props.match.params.probeuid +
                              ".csv";

                            this.downloadCsv(bssid, csv);
                          }}
                        >
                          CSV
                        </ReactOButton>
                        <ReactOTooltip
                          placement="right"
                          target="csv_tooltip_m"
                          delay={{ show: 200 }}
                          text={
                            this.state.measure_graph &&
                            this.state.measure_graph.graphData &&
                            this.state.measure_graph.graphData.measures_count &&
                            this.state.measure_graph.graphData.measures_count >
                              0
                              ? this.getAppContext().conf.CSV_data
                              : this.getAppContext().conf.CSV_no_data
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
            </_LoadingWrapper>
          </Panel>
        </Section>

        <Section designType="wide" className="mx-4 mb-3">
          <Row>
            <Col lg="6" md="12">
              <Panel
                padding="0"
                bodyClassName="p-0"
                rounded
                header={
                  <div>
                    <span>SPLIT TIME ON TEST STEPS</span>{" "}
                    <small className="text-muted ml-1">
                      {this.getAppContext().media.isMobile ||
                      this.getAppContext().media.isTablet ? (
                        <br />
                      ) : null}
                      (For selected view range)
                    </small>
                  </div>
                }
              >
                <_LoadingWrapper
                  minHeight
                  loadingPlug={
                    (this.state.loading && !this._IS_AUTO_RELOADING) ||
                    (!this.state.timingView && this.state.loadingStepTiming)
                  }
                >
                  {(() => {
                    if (this.state.measure_graph.graphData) {
                      this._total_avg_time = 0;
                      let _top_avg_data_idx = undefined;
                      let _avg_data = [];

                      this.state.measure_graph.graphData.phases_sequence
                        .filter((elem) => elem != "DISCEARLY")
                        .forEach((_CURR_phase, _CURR_idx) => {
                          this._total_avg_time = this.state.measure_graph
                            .graphData.phases_timing[_CURR_phase]
                            ? this._total_avg_time +
                              parseFloat(
                                this.state.measure_graph.graphData
                                  .phases_timing[_CURR_phase],
                              )
                            : this._total_avg_time;

                          let _CURR_avg_data = this.state.measure_graph
                            .graphData.phases_timing[_CURR_phase]
                            ? {
                                phase: _CURR_phase,
                                time: this.state.measure_graph.graphData
                                  .phases_timing[_CURR_phase]
                                  ? parseFloat(
                                      this.state.measure_graph.graphData
                                        .phases_timing[_CURR_phase],
                                    )
                                  : 0,
                                color:
                                  this.state.measure_graph.graphData
                                    .phases_colors.measures[_CURR_phase],
                                phase_order:
                                  this.state.measure_graph.graphData.phases_sequence.indexOf(
                                    _CURR_phase,
                                  ),
                              }
                            : this.state.measure_graph.graphData.phases_timing[
                                  _CURR_phase
                                ] == null &&
                                this.state.measure_graph.graphData
                                  .measures_count
                              ? {
                                  phase: _CURR_phase,
                                  time: 0,
                                  color:
                                    this.state.measure_graph.graphData
                                      .phases_colors.measures[_CURR_phase],
                                  phase_order:
                                    this.state.measure_graph.graphData.phases_sequence.indexOf(
                                      _CURR_phase,
                                    ),
                                  is_null: true,
                                }
                              : null;
                          _top_avg_data_idx =
                            _top_avg_data_idx == undefined
                              ? _CURR_avg_data
                                ? _CURR_idx
                                : undefined
                              : _CURR_avg_data &&
                                  _CURR_avg_data.time &&
                                  _avg_data[_top_avg_data_idx] &&
                                  _avg_data[_top_avg_data_idx].time &&
                                  _CURR_avg_data.time >
                                    _avg_data[_top_avg_data_idx].time
                                ? _CURR_idx
                                : _top_avg_data_idx;
                          if (_CURR_avg_data) {
                            _avg_data.push(_CURR_avg_data);
                          }
                        });
                      return _avg_data.length > 0 ? (
                        <div>
                          {!this.getAppContext().media.isMobile &&
                          !this.getAppContext().media.isTablet ? (
                            <Row noGutters>
                              <Col xs={5}>
                                <PieChart
                                  dataKey="time"
                                  style={{ cursor: "pointer" }}
                                  nameKey="phase"
                                  data={_avg_data}
                                  default={_top_avg_data_idx}
                                  tooltip={{ text: "Show step chart" }}
                                  onControllerReady={(pie_controller) => {
                                    this._pie_chart = pie_controller;
                                  }}
                                  onClick={(data) => {
                                    if (!this.state.loadingStepTiming) {
                                      let storedViewrange = {
                                        ...this.getAppContext()
                                          .getLocalStorageService()
                                          .get("measure_graph_view"),
                                      };

                                      if (storedViewrange.is_preset == "yes") {
                                        let sourceViewrange = {
                                          ...this.state.measure_graph
                                            .viewRangeData,
                                        };
                                        sourceViewrange.is_preset = "no";
                                        sourceViewrange.view_preset = "no";
                                        if (sourceViewrange.offset) {
                                          delete sourceViewrange.offset;
                                        }
                                        this.getAppContext()
                                          .getLocalStorageService()
                                          .set(
                                            "measure_steplist_view",
                                            sourceViewrange,
                                          );
                                        this.loadSteptiming(data.name);
                                      } else if (
                                        storedViewrange.is_preset == "no"
                                      ) {
                                        this.getAppContext()
                                          .getLocalStorageService()
                                          .set(
                                            "measure_steplist_view",
                                            storedViewrange,
                                          );
                                        this.loadSteptiming(data.name);
                                      }
                                    }
                                  }}
                                  onSetActive={(item, item_index) => {
                                    this.setState({
                                      activePieItem: item
                                        ? {
                                            ...item,
                                            ...{ _index: item_index },
                                          }
                                        : undefined,
                                    });
                                  }}
                                  onUnsetActive={(item, item_index) => {
                                    this.setState({
                                      activePieItem: item
                                        ? {
                                            ...item,
                                            ...{ _index: item_index },
                                          }
                                        : undefined,
                                    });
                                  }}
                                />
                              </Col>
                              {this.state.activePieItem ? (
                                <Col className="d-flex mr-4">
                                  <div className="flex-grow-1 align-self-center">
                                    <div
                                      className="pb-2 border-bottom border-2 border-gray300 d-flex"
                                      style={{
                                        color: this.state.activePieItem.color,
                                      }}
                                    >
                                      <h4>{this.state.activePieItem.phase}</h4>{" "}
                                      {this.state.activePieItem._index ==
                                      _top_avg_data_idx ? (
                                        <small className="text-muted align-self-end ml-2">
                                          <span className="icon-warning mr-2" />
                                          (longest)
                                        </small>
                                      ) : null}
                                    </div>
                                    <Row>
                                      <Col className="d-flex flex-column border-right border-gray300 p-3">
                                        <small className="text-muted mb-2">
                                          <strong>AVG. TIME (%)</strong>
                                        </small>
                                        <div className="d-flex h-100 align-items-center">
                                          <h4>
                                            {(
                                              (this.state.activePieItem.time /
                                                this._total_avg_time) *
                                              100
                                            ).toFixed(1)}{" "}
                                            %
                                          </h4>
                                        </div>
                                      </Col>
                                      <Col className="d-flex flex-column p-3">
                                        <small className="text-muted mb-2">
                                          <strong>STEP AVG. TIME</strong>
                                        </small>
                                        <div className="d-flex h-100 align-items-center">
                                          <h4>
                                            {this.state.activePieItem.time} ms
                                          </h4>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          ) : null}
                          <ReactOTable
                            thClassName="px-3 py-1"
                            tdClassName="tealign-middle px-3 py-1"
                            hoverable
                            compressed={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                            }
                            compressedRowRendering={(row_items) => {
                              return (
                                <div>
                                  <div className="text-center">
                                    {row_items.phase.content}
                                  </div>
                                  <Row className="mt-2">
                                    <Col>
                                      <div className="text-muted">
                                        <small className="">
                                          <strong>
                                            {row_items.time_perc.title}
                                          </strong>
                                        </small>
                                      </div>
                                      {row_items.time_perc.content}
                                    </Col>
                                    <Col>
                                      <div className="text-muted">
                                        <small className="">
                                          <strong>
                                            {row_items.time.title}
                                          </strong>
                                        </small>
                                      </div>
                                      {row_items.time.content}
                                    </Col>
                                  </Row>
                                </div>
                              );
                            }}
                            thDividers
                            style={{ cursor: "pointer" }}
                            onTableLeave={
                              !this.getAppContext().media.isMobile &&
                              !this.getAppContext().media.isTablet
                                ? () => {
                                    this._pie_chart.unsetActive();
                                  }
                                : null
                            }
                            onRowOver={
                              !this.getAppContext().media.isMobile &&
                              !this.getAppContext().media.isTablet
                                ? (row_data) => {
                                    this._pie_chart.setActive(
                                      _avg_data[row_data.index],
                                      row_data.index,
                                    );
                                  }
                                : null
                            }
                            defaultSort={[
                              {
                                data_key: "time_perc",
                                order: "desc",
                              },
                            ]}
                            cols={[
                              {
                                title: "STEP",
                                data_key: "phase",
                                width: "35",
                                sortable: true,
                                oneway_sort: true,
                              },
                              {
                                title: "AVG. TIME (%)",
                                align: "center",
                                data_key: "time_perc",
                                width: "35",
                                sortable: true,
                              },
                              {
                                title: "AVG. TIME",
                                align: "center",
                                data_key: "time",
                                width: "30",
                                sortable: true,
                              },
                            ]}
                            onRowClick={(row_data) => {
                              // console.log("row_data", row_data);
                              if (
                                !this.state.loadingStepTiming &&
                                !row_data.is_null
                              ) {
                                let storedViewrange = {
                                  ...this.getAppContext()
                                    .getLocalStorageService()
                                    .get("measure_graph_view"),
                                };

                                if (storedViewrange.is_preset == "yes") {
                                  let sourceViewrange = {
                                    ...this.state.measure_graph.viewRangeData,
                                  };
                                  sourceViewrange.is_preset = "no";
                                  sourceViewrange.view_preset = "no";
                                  if (sourceViewrange.offset) {
                                    delete sourceViewrange.offset;
                                  }
                                  this.getAppContext()
                                    .getLocalStorageService()
                                    .set(
                                      "measure_steplist_view",
                                      sourceViewrange,
                                    );
                                  this.loadSteptiming(row_data.phase.step);
                                } else if (storedViewrange.is_preset == "no") {
                                  this.getAppContext()
                                    .getLocalStorageService()
                                    .set(
                                      "measure_steplist_view",
                                      storedViewrange,
                                    );
                                  this.loadSteptiming(row_data.phase.step);
                                }
                              }
                            }}
                            rows={(() => {
                              let _TMP = [];
                              _avg_data.forEach((_CURR_phase, _CURR_idx) => {
                                // console.log("(_CURR_phase", _CURR_phase);
                                _TMP.push({
                                  index: _CURR_idx,
                                  className: _CURR_phase.is_null
                                    ? "text-gray500"
                                    : "",
                                  _rowTooltip: {
                                    targetId:
                                      "_tp_" +
                                      _CURR_phase.phase +
                                      "_" +
                                      _CURR_idx,
                                    text: _CURR_phase.is_null
                                      ? "Step not configured to run in this time interval"
                                      : "Show step chart",
                                    delay: { show: 200 },
                                  },
                                  is_null: _CURR_phase.is_null,
                                  phase: {
                                    value: _CURR_phase.phase_order,
                                    step: _CURR_phase.phase,
                                    render: (
                                      <div className="d-flex">
                                        <div
                                          className="mr-2"
                                          style={{
                                            backgroundColor:
                                              this.state.measure_graph.graphData
                                                .phases_colors.measures[
                                                _CURR_phase.phase
                                              ],
                                            width: "30px",
                                            height: "30px",
                                          }}
                                        />
                                        <div className="align-self-center">
                                          {_CURR_phase.phase}
                                        </div>
                                      </div>
                                    ),
                                  },
                                  time: {
                                    value: _CURR_phase.time,
                                    render: (
                                      <span>
                                        {_CURR_phase.time
                                          ? _CURR_phase.time + " ms"
                                          : "-"}
                                      </span>
                                    ),
                                  },
                                  time_perc: {
                                    value: (
                                      (_CURR_phase.time /
                                        this._total_avg_time) *
                                      100
                                    ).toFixed(1),
                                    render: (
                                      <strong>
                                        {_CURR_phase.time
                                          ? (
                                              (_CURR_phase.time /
                                                this._total_avg_time) *
                                              100
                                            ).toFixed(1) + " %"
                                          : "-"}
                                      </strong>
                                    ),
                                  },
                                });
                              });
                              return _TMP;
                            })()}
                          />
                          <div className="text-right bg-gray150 border-top rounded-bottom py-3 px-4">
                            <small>
                              <span className="text-muted">
                                TOTAL AVG. TIME:
                              </span>{" "}
                              {this._total_avg_time} ms
                            </small>
                          </div>
                        </div>
                      ) : (
                        <h4 className="text-gray400 text-center mt-3">
                          No data available
                        </h4>
                      );
                    } else {
                      return null;
                    }
                  })()}
                </_LoadingWrapper>
              </Panel>
            </Col>
            <Col
              lg="6"
              md="12"
              className={
                this.getAppContext().media.isDesktop ||
                this.getAppContext().media.isTablet
                  ? "mt-3"
                  : ""
              }
            >
              <Panel
                padding="0"
                bodyClassName="p-0"
                rounded
                header={
                  <div>
                    <span>ERRORS STATISTICS</span>{" "}
                    <small className="text-muted ml-1">
                      (For selected view range)
                    </small>
                  </div>
                }
              >
                <_LoadingWrapper
                  minHeight
                  loadingPlug={this.state.loading && !this._IS_AUTO_RELOADING}
                >
                  {(() => {
                    if (this.state.measure_graph.graphData) {
                      let _errors_stat =
                        this.state.measure_graph.graphData.errors_statistics
                          .details;
                      let _total_errors =
                        this.state.measure_graph.graphData.errors_statistics
                          .total;
                      let _errors_stat_totals = {};
                      let _total_over10 =
                        this.state.measure_graph.graphData.over10_count;
                      let _total =
                        this.state.measure_graph.graphData.measures_count;
                      let _top_pie_data_idx = undefined;
                      let _top_pie_data = undefined;
                      let _pie_data = [];
                      let listErrorSteps = {};
                      Object.keys(_errors_stat).forEach(
                        (_CURR_stat_ts, _CURR_idx1) => {
                          Object.keys(_errors_stat[_CURR_stat_ts]).forEach(
                            (_CURR_stat_phase, _CURR_idx2) => {
                              // if (listErrorSteps.indexOf(_CURR_stat_phase) === -1) {
                              //   listErrorSteps.push(_CURR_stat_phase);
                              // }

                              listErrorSteps[_CURR_stat_phase] =
                                this.state.measure_graph.graphData.phases_colors.errors[
                                  _CURR_stat_phase
                                ];

                              if (!_errors_stat_totals[_CURR_stat_phase]) {
                                _errors_stat_totals[_CURR_stat_phase] = {
                                  total: 0,
                                  list: [],
                                };
                              }
                              _errors_stat_totals[_CURR_stat_phase].total =
                                _errors_stat_totals[_CURR_stat_phase].total +
                                _errors_stat[_CURR_stat_ts][_CURR_stat_phase];
                              _errors_stat_totals[_CURR_stat_phase].list.push({
                                ts: _CURR_stat_ts,
                                errors_count:
                                  _errors_stat[_CURR_stat_ts][_CURR_stat_phase],
                              });
                              //	_total_errors = _total_errors + _errors_stat[_CURR_stat_ts][_CURR_stat_phase];
                            },
                          );
                        },
                      );
                      // console.log("listErrorSteps", listErrorSteps);
                      let _c = 0;
                      // if (
                      //   this.state.measure_graph.graphData.phases_sequence.indexOf(
                      //     "DISCEARLY"
                      //   ) != -1
                      // ) {
                      //   _c =
                      //     this.state.measure_graph.graphData.phases_sequence.indexOf(
                      //       "DISCEARLY"
                      //     );
                      // }
                      _pie_data =
                        this.state.measure_graph.graphData.phases_sequence
                          .map((_C_phase, _C_idx) => {
                            if (_errors_stat_totals[_C_phase]) {
                              let _new_top =
                                _top_pie_data === undefined
                                  ? _errors_stat_totals[_C_phase].total
                                  : _errors_stat_totals[_C_phase].total >
                                      _top_pie_data
                                    ? _errors_stat_totals[_C_phase].total
                                    : _top_pie_data;
                              _top_pie_data_idx =
                                _top_pie_data_idx == undefined
                                  ? _c
                                  : _errors_stat_totals[_C_phase].total >
                                      _top_pie_data
                                    ? _c
                                    : _top_pie_data_idx;
                              _top_pie_data = _new_top;
                              _errors_stat_totals[
                                _C_phase
                              ]._pie_filtered_index = _c;
                              _c = _c + 1;

                              return {
                                phase: _C_phase,
                                errors: _errors_stat_totals[_C_phase].total,
                                color:
                                  _C_phase != "DISCEARLY"
                                    ? this.state.measure_graph.graphData
                                        .phases_colors.measures[_C_phase]
                                    : this.state.measure_graph.graphData
                                        .phases_colors.errors[_C_phase],
                                perimeterStroke: true,
                              };
                            } else {
                              return null;
                            }
                          })
                          .filter((value) => {
                            return value;
                          });

                      _pie_data.push({
                        phase: "_other_ok",
                        errors: _total - _total_errors,
                        color: "#337ab755",
                        total: _total,
                      });

                      // const discearlyIdx = _pie_data.findIndex(
                      //   (d) => d.phase == "DISCEARLY"
                      // );

                      // this.errorReport = _pie_data;

                      return _total > 0 ? (
                        <div>
                          <Section
                            designType="wide"
                            layoutManager="grid"
                            elementsPerRow={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                                ? 2
                                : 3
                            }
                            gridSpacing={1}
                            gridSpacingColor={
                              this.getAppContext().colors.gray300
                            }
                          >
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (_total_errors > 0) {
                                  let dataToSend = this.getAppContext()
                                    .getLocalStorageService()
                                    .get("measure_graph_view");
                                  this.loadErrorGraph(dataToSend);
                                }
                              }}
                              className="d-flex flex-column p-3"
                            >
                              <small className="text-muted mb-2">
                                <strong>
                                  ERRORS COUNT{" "}
                                  {/* <span className="ml-1 text-secondary icon-stats-bars" /> */}
                                </strong>
                              </small>
                              <div className="d-flex">
                                <h4
                                  className={
                                    _total_errors > 0 ? " text-danger" : ""
                                  }
                                >
                                  {_total_errors} (
                                  {Math.round(
                                    (_total_errors / _total) * 100 * 10,
                                  ) / 10 || 0}
                                  %)
                                </h4>
                                <div
                                  id="tp_error_freq_chart"
                                  className="ml-auto"
                                >
                                  {/* <strong>
                                    <small className="text-secondary icon-stats-bars" />
                                  </strong> */}
                                  <ReactOButton
                                    icon="stats-bars"
                                    size="sm"
                                    color="secondary"
                                    disabled={_total_errors == 0}
                                    outline
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      if (_total_errors > 0) {
                                        let dataToSend = this.getAppContext()
                                          .getLocalStorageService()
                                          .get("measure_graph_view");
                                        this.loadErrorGraph(dataToSend);
                                      }
                                    }}
                                  />
                                  <ReactOTooltip
                                    placement="bottom"
                                    target="tp_error_freq_chart"
                                    text={
                                      _total_errors > 0
                                        ? "Show errors frequency chart"
                                        : "No errors to show"
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                            <div
                              id="_tp_slow_measures"
                              className="d-flex flex-column p-3"
                            >
                              <small className="text-muted mb-2">
                                <strong>SLOW MEASURES COUNT</strong>
                              </small>
                              <div className="d-flex h-100 align-items-center">
                                <h4>
                                  {this.state.measure_graph.graphData.rrd_step >
                                  60 ? (
                                    <span>
                                      --
                                      <br />
                                      <small className="sub-title">
                                        Data not available for selected view
                                        range
                                      </small>
                                    </span>
                                  ) : (
                                    <span>
                                      <span>
                                        {_total_over10} (
                                        {Math.round(
                                          (_total_over10 / _total) * 100 * 10,
                                        ) / 10 || 0}
                                        %)
                                      </span>
                                    </span>
                                  )}
                                </h4>
                              </div>
                              <ReactOTooltip
                                placement="bottom"
                                target="_tp_slow_measures"
                                text={
                                  <span>
                                    Based on the{" "}
                                    <strong>Y Reference Time</strong> value
                                    configured on the measure (
                                    {this.state.measure_graph.Yref}s)
                                  </span>
                                }
                              />
                            </div>

                            <div
                              id="_tp_measures_count"
                              className="d-flex flex-column p-3"
                            >
                              <small className="text-muted mb-2">
                                <strong>MEASURES COUNT</strong>
                              </small>
                              <div className="d-flex h-100 align-items-center">
                                <h4>
                                  {this.state.measure_graph.graphData.rrd_step >
                                  60 ? (
                                    <span>
                                      --
                                      <br />
                                      <small className="sub-title">
                                        Data not available for selected view
                                        range
                                      </small>
                                    </span>
                                  ) : (
                                    <span>
                                      <span id="_tp_measures_count">
                                        {_total}
                                      </span>
                                    </span>
                                  )}
                                </h4>
                              </div>
                              {this.state.measure_graph.graphData.rrd_step <=
                                60 && (
                                <ReactOTooltip
                                  placement="bottom"
                                  target="_tp_measures_count"
                                  text={`Measures count on ${
                                    this.state.measure_graph.viewRangeData
                                      .etime -
                                      this.state.measure_graph.viewRangeData
                                        .stime <
                                    86400
                                      ? (this.state.measure_graph.viewRangeData
                                          .etime -
                                          this.state.measure_graph.viewRangeData
                                            .stime) /
                                          3600 +
                                        "h"
                                      : (this.state.measure_graph.viewRangeData
                                          .etime -
                                          this.state.measure_graph.viewRangeData
                                            .stime) /
                                          86400 +
                                        "d"
                                  }`}
                                />
                              )}
                            </div>
                          </Section>
                          {_total_errors &&
                          !this.getAppContext().media.isMobile &&
                          !this.getAppContext().media.isTablet > 0 ? (
                            <Row
                              noGutters
                              className=" border-top border-gray300"
                            >
                              <Col xs={4}>
                                <PieChart
                                  dataKey="errors"
                                  nameKey="phase"
                                  style={{ cursor: "pointer" }}
                                  data={_pie_data}
                                  // default={
                                  //   discearlyIdx != -1 ? discearlyIdx : _top_pie_data_idx
                                  // }
                                  default={_top_pie_data_idx}
                                  innerRadius="33"
                                  perimeterStroke={{
                                    width: 10,
                                    color: this.getAppContext().colors.danger,
                                    colorsObj: listErrorSteps,
                                  }}
                                  onControllerReady={(pie_controller) => {
                                    this._pie_chart2 = pie_controller;
                                  }}
                                  onSetActive={(item, item_index) => {
                                    this.setState({
                                      activePie2Item: item
                                        ? {
                                            ...item,
                                            ...{ _index: item_index },
                                          }
                                        : undefined,
                                    });
                                  }}
                                  onUnsetActive={(item, item_index) => {
                                    this.setState(
                                      { activePie2Item: undefined },
                                      () => {
                                        this.setState({
                                          activePie2Item: item
                                            ? {
                                                ...item,
                                                ...{ _index: item_index },
                                              }
                                            : undefined,
                                        });
                                      },
                                    );
                                  }}
                                  onClick={(data) => {
                                    // console.log("data", data);
                                    if (
                                      _errors_stat_totals[data.phase] &&
                                      _errors_stat_totals[data.phase].total > 0
                                    ) {
                                      this._errors_index_modal.open({
                                        phases_sequence:
                                          this.state.measure_graph.graphData
                                            .phases_sequence,
                                        errors_statistics: _errors_stat_totals,
                                        stime:
                                          this.state.measure_graph.viewRangeData
                                            .stime,
                                        etime:
                                          this.state.measure_graph.viewRangeData
                                            .etime,
                                        selected: data.phase,
                                        total: _total,
                                        total_errors: _total_errors,
                                      });
                                    }
                                  }}
                                />
                              </Col>
                              {this.state.activePie2Item ? (
                                <Col className="d-flex mr-4">
                                  <div className="flex-grow-1 align-self-center">
                                    <div
                                      className="pb-2 border-bottom border-2 border-gray300 d-flex"
                                      style={{
                                        color:
                                          this.state.activePie2Item.phase ==
                                          "_other_ok"
                                            ? this.getAppContext().colors
                                                .gray600
                                            : this.state.activePie2Item.color,
                                      }}
                                    >
                                      <h4>
                                        {this.state.activePie2Item.phase ==
                                        "_other_ok"
                                          ? "Measure with no errors"
                                          : this.state.activePie2Item.phase ==
                                              "DISCEARLY"
                                            ? "Early drop by AP"
                                            : this.state.activePie2Item.phase}
                                      </h4>{" "}
                                      {/*this.state.activePie2Item._index == _top_pie_data_idx ? (<small className="text-muted align-self-end ml-2"><span className="icon-warning mr-2"/>(longest)</small>) : null*/}
                                    </div>
                                    <Row>
                                      <Col className="d-flex flex-column border-right border-gray300 p-3">
                                        <small className="text-muted mb-2">
                                          <strong>PERC.</strong>
                                        </small>
                                        <div className="d-flex h-100 align-items-center">
                                          <h4>
                                            {(
                                              (this.state.activePie2Item
                                                .errors /
                                                _total) *
                                              100
                                            ).toFixed(1)}{" "}
                                            %
                                          </h4>
                                          {this.state.activePie2Item.phase !=
                                          "_other_ok" ? (
                                            <span className="text-gray500 ml-2">
                                              (
                                              {(
                                                (this.state.activePie2Item
                                                  .errors /
                                                  _total_errors) *
                                                100
                                              ).toFixed(1)}{" "}
                                              %)
                                            </span>
                                          ) : null}
                                        </div>
                                      </Col>
                                      <Col className="d-flex flex-column p-3">
                                        <small className="text-muted mb-2">
                                          <strong>COUNT</strong>
                                        </small>
                                        <div className="d-flex h-100 align-items-center">
                                          <h4>
                                            {this.state.activePie2Item.errors}
                                          </h4>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              ) : null}
                            </Row>
                          ) : null}

                          {_total_errors > 0 ? (
                            <ReactOTable
                              thClassName="px-3 py-1"
                              tdClassName="align-middle px-3 py-1"
                              hoverable
                              compressed={
                                this.getAppContext().media.isMobile ||
                                this.getAppContext().media.isTablet
                              }
                              compressedRowRendering={(row_items) => {
                                return (
                                  <div>
                                    <div className="text-center">
                                      {row_items.phase.content}
                                    </div>
                                    <div className="mt-2">
                                      <div className="text-muted">
                                        <small className="">
                                          <strong>
                                            {row_items.errors_count.title}
                                          </strong>
                                        </small>
                                      </div>
                                      {row_items.errors_count.content}
                                    </div>
                                    <Row className="mt-2">
                                      <Col>
                                        <div className="text-muted">
                                          <small className="">
                                            <strong>
                                              {
                                                row_items.mea_errors_count_perc
                                                  .title
                                              }
                                            </strong>
                                          </small>
                                        </div>
                                        {
                                          row_items.mea_errors_count_perc
                                            .content
                                        }
                                      </Col>
                                      <Col>
                                        <div className="text-muted">
                                          <small className="">
                                            <strong>
                                              {
                                                row_items.errors_count_perc
                                                  .title
                                              }
                                            </strong>
                                          </small>
                                        </div>
                                        {row_items.errors_count_perc.content}
                                      </Col>
                                    </Row>
                                  </div>
                                );
                              }}
                              thDividers
                              onTableLeave={
                                !this.getAppContext().media.isMobile &&
                                !this.getAppContext().media.isTablet
                                  ? () => {
                                      this._pie_chart2.unsetActive();
                                    }
                                  : null
                              }
                              onRowOver={
                                !this.getAppContext().media.isMobile &&
                                !this.getAppContext().media.isTablet
                                  ? (row_data) => {
                                      this._pie_chart2.setActive(
                                        _pie_data[row_data.index],
                                        row_data.index,
                                      );
                                    }
                                  : null
                              }
                              onRowClick={
                                this.props.onItemClick
                                  ? this.props.onItemClick
                                  : (row_data) => {
                                      this._errors_index_modal.open({
                                        phases_sequence:
                                          this.state.measure_graph.graphData
                                            .phases_sequence,
                                        errors_statistics: _errors_stat_totals,
                                        stime:
                                          this.state.measure_graph.viewRangeData
                                            .stime,
                                        etime:
                                          this.state.measure_graph.viewRangeData
                                            .etime,
                                        selected: row_data.phase.value,
                                        total: _total,
                                        total_errors: _total_errors,
                                      });
                                    }
                              }
                              defaultSort={[
                                {
                                  data_key: "errors_count_perc",
                                  order: "desc",
                                },
                              ]}
                              cols={[
                                {
                                  title: "STEP",
                                  data_key: "phase",
                                  width: "30",
                                  sortable: true,
                                },
                                {
                                  title: "% ON MEASURES COUNT",
                                  align: "center",
                                  data_key: "mea_errors_count_perc",
                                  width: "30",
                                  sortable: true,
                                },
                                {
                                  title: "% ON ERRORS COUNT",
                                  align: "center",
                                  data_key: "errors_count_perc",
                                  width: "20",
                                  sortable: true,
                                },
                                {
                                  title: "ERRORS COUNT",
                                  align: "center",
                                  data_key: "errors_count",
                                  width: "20",
                                  sortable: true,
                                },
                              ]}
                              style={{ cursor: "pointer" }}
                              rows={(() => {
                                let _TMP = [];
                                this.state.measure_graph.graphData.phases_sequence.forEach(
                                  (_CURR_phase, _CURR_idx) => {
                                    if (_errors_stat_totals[_CURR_phase]) {
                                      _TMP.push({
                                        _rowTooltip: {
                                          targetId:
                                            "_tp_" +
                                            _CURR_phase.phase +
                                            "_2_" +
                                            _CURR_idx,
                                          text: "Show errors list",
                                          delay: { show: 200 },
                                        },
                                        index:
                                          _errors_stat_totals[_CURR_phase]
                                            ._pie_filtered_index,
                                        phase: {
                                          value: _CURR_phase,
                                          render: (
                                            <div className="d-flex align-items-center">
                                              <div
                                                className="mr-2"
                                                style={{
                                                  backgroundSize: "140%",
                                                  backgroundImage:
                                                    _CURR_phase == "DISCEARLY"
                                                      ? "url(/pattern_wfp.png)"
                                                      : "",
                                                  backgroundColor:
                                                    this.state.measure_graph
                                                      .graphData.phases_colors
                                                      .measures[_CURR_phase],
                                                  width: "30px",
                                                  height: "30px",
                                                }}
                                              />
                                              <div className="align-self-center text-nowrap">
                                                {_CURR_phase == "DISCEARLY"
                                                  ? "Early drop"
                                                  : _CURR_phase}
                                              </div>
                                            </div>
                                          ),
                                        },
                                        errors_count:
                                          _errors_stat_totals[_CURR_phase]
                                            .total,
                                        mea_errors_count_perc: {
                                          value: (
                                            (_errors_stat_totals[_CURR_phase]
                                              .total /
                                              _total) *
                                            100
                                          ).toFixed(1),
                                          render: (
                                            <strong>
                                              {(
                                                (_errors_stat_totals[
                                                  _CURR_phase
                                                ].total /
                                                  _total) *
                                                100
                                              ).toFixed(1)}{" "}
                                              %
                                            </strong>
                                          ),
                                        },
                                        errors_count_perc: {
                                          value: (
                                            (_errors_stat_totals[_CURR_phase]
                                              .total /
                                              _total_errors) *
                                            100
                                          ).toFixed(1),
                                          render: (
                                            <strong>
                                              {(
                                                (_errors_stat_totals[
                                                  _CURR_phase
                                                ].total /
                                                  _total_errors) *
                                                100
                                              ).toFixed(1)}{" "}
                                              %
                                            </strong>
                                          ),
                                        },
                                      });
                                    }
                                  },
                                );
                                this._errorList = _TMP;
                                return _TMP;
                              })()}
                            />
                          ) : null}
                        </div>
                      ) : (
                        <h4 className="text-gray400 text-center mt-3">
                          No data available
                        </h4>
                      );
                    } else {
                      return null;
                    }
                  })()}
                </_LoadingWrapper>
              </Panel>
            </Col>
          </Row>
        </Section>

        {/*				
// Modals
///////////////////////*/}

        <ReactOModal
          modalId="stepTiming"
          bodyClassName="stepTiming-body-modal"
          size="xl"
          // className="modal-timing"
          onControllerReady={(modal_context) => {
            this._stepTiming_modal = modal_context;
          }}
          onModalMounted={(data) => {
            if (
              data.graphData.errors_count > 0 &&
              !this._errorGraph_modal.isOpen()
            ) {
              // PROCESS ERROR FOR STEPTIMING ERROR SWITCH
              // -----------------------------------------------------

              const { stime, etime } = data.viewRangeData;

              // stime, etime normalized hour

              let etimeHourRaw = etime - (etime % 3600);
              let now = Math.round(Date.now() / 1000);
              let nowHour = now - (now % 3600);

              const stimeHour = stime - (stime % 3600);
              const etimeHour =
                etimeHourRaw < nowHour ? etimeHourRaw + 3600 : etimeHourRaw;

              // API Call with stime / etime per Hour

              this.callsSet.call("get_step_graph_error", {
                data_input: {
                  viewrange: {
                    ...data.viewRangeData,
                    stime: stimeHour,
                    etime: etimeHour,
                  },
                  stepList: [Object.values(data.formInit)[0]],
                  Yref: 10,
                },
                on_success: (_, response_data) => {
                  // console.log("fire -> ", response_data[0].data);

                  // ERROR PROCESS
                  const { graphData } = response_data[0].data;
                  const start_time = parseInt(graphData.ImgStart);
                  const end_time = parseInt(graphData.ImgEnd);
                  const { errors_statistics } = graphData;

                  let raw_errors = [];
                  let arrayOfErrors = [];
                  let objectOfErrors = {};
                  if (graphData && graphData.errors_statistics.details) {
                    Object.keys(errors_statistics.details).forEach((ts, id) => {
                      Object.keys(errors_statistics.details[ts]).forEach(
                        (phase) => raw_errors.push(phase),
                      );
                      Object.keys(errors_statistics.details[ts]).forEach(
                        (phase) => {
                          if (!objectOfErrors[phase]) {
                            objectOfErrors[phase] = 0;
                          }
                        },
                      );
                    });
                    arrayOfErrors = [...new Set(raw_errors)];
                    this.setState({ arrayOfErrors: arrayOfErrors });
                  }
                  let hourNumber = [];

                  for (let t = start_time + 3600; t <= end_time; t = t + 3600) {
                    hourNumber.push(t);
                  }
                  let resulted = {};

                  hourNumber.forEach((t, id, array) => {
                    let errors = { ...objectOfErrors };
                    // errors._tot = 0;
                    Object.keys(objectOfErrors).forEach((phase) => {
                      Object.keys(errors_statistics.details).forEach((ts) => {
                        if (ts <= t && ts >= t - 3600) {
                          if (errors_statistics.details[ts][phase]) {
                            let current = parseInt(errors[phase]);
                            let increment =
                              current +
                              parseInt(errors_statistics.details[ts][phase]);
                            errors[phase] = increment;
                          }
                        }
                      });
                    });
                    // console.log("errors", errors);
                    let total = 0;

                    Object.values(errors).forEach((n) => {
                      // console.log("n", n);
                      total = total + n;
                      // console.log("total", total);
                    });

                    resulted[t] = errors;
                    resulted[t].tot = total;
                  });

                  // console.log("resulted", resulted);

                  let maxErrorPerHour = { ...objectOfErrors };
                  maxErrorPerHour.maxValue = 0;

                  Object.keys(objectOfErrors).forEach((phase) => {
                    Object.keys(resulted).forEach((ts) => {
                      if (resulted[ts][phase] > maxErrorPerHour[phase])
                        maxErrorPerHour[phase] = resulted[ts][phase];

                      if (resulted[ts][phase] > maxErrorPerHour.maxValue) {
                        maxErrorPerHour.maxValue = resulted[ts][phase];
                      }
                    });
                  });

                  // -----------------------------------------------------
                  this.setState({
                    maxErrorPerHour: maxErrorPerHour,
                    errorPerHour: resulted,
                    invalidYref: false,
                    startSpin: false,
                    errorViewRange: {
                      ...data.viewRangeData,
                      stime: stimeHour,
                      etime: etimeHour,
                    },
                    timingView: true,
                    inputFieldValueModal:
                      this.state.inputFieldValue ||
                      this.state.measure_graph.Yref,
                  });
                },
              });
            } else if (this._errorGraph_modal.isOpen()) {
              this.setState({
                timingView: true,
                invalidYref: false,
                startSpin: false,
              });
            } else {
              this.setState({
                timingView: true,
                inputFieldValueModal:
                  this.state.inputFieldValue || this.state.measure_graph.Yref,
                invalidYref: false,
                startSpin: false,
              });
            }
          }}
          onModalUnmounted={(data) => {
            if (!this._errorGraph_modal.isOpen()) {
              this.setState(
                {
                  timingView: false,
                  switchError: false,
                  maxErrorPerHour: null,
                  errorPerHour: null,
                  errorViewRange: null,
                  customYrefModal: undefined,
                  // inputFieldValue: this.state.measure_graph.Yref,
                },
                () => {
                  this.getAppContext()
                    .getLocalStorageService()
                    .remove("measure_steplist_view");
                },
              );
            } else {
              this.setState(
                {
                  timingView: false,
                  switchError: false,
                  customYrefModal: undefined,
                  // inputFieldValue: this.state.measure_graph.Yref,
                },
                () => {
                  this.getAppContext()
                    .getLocalStorageService()
                    .remove("measure_steplist_view");
                },
              );
            }
          }}
          modalClassName="modal-stepTiming-header"
          header={(data) => {
            let sTimeView = data.viewRangeData.stime;
            let eTimeView = data.viewRangeData.etime;

            if (this.state.switchError) {
              sTimeView = this.state.errorViewRange.stime;
              eTimeView = this.state.errorViewRange.etime;
            }

            return (
              <div className="stepTiming-steptiming">
                {`${
                  this.state.switchError ? "Errors on steps" : "Times on steps"
                } for measure: `}
                {this._measureInfo.name ? (
                  <span>
                    {this._measureInfo.name}
                    {!this.getAppContext().media.isMobile &&
                    !this.getAppContext().media.isTablet ? (
                      <span className="icon-navigate-next align-middle mx-1" />
                    ) : (
                      <br />
                    )}
                    {this.props.match.params.bssid == "overal" ? (
                      "Overall chart"
                    ) : (
                      <span>
                        {this._measureInfo.bssid_info &&
                        this._measureInfo.bssid_info.ap_custom_data ? (
                          <strong>
                            <span>
                              {this._measureInfo.bssid_info.ap_custom_data.name}
                            </span>
                          </strong>
                        ) : (
                          <strong>
                            <span>{this._measureInfo.bssid}</span>
                          </strong>
                        )}
                      </span>
                    )}
                    {/ethernet/i.test(this.state.measure_graph.essid) ||
                    this.props.match.params.bssid == "overal" ? null : (
                      <span className="mx-1 ">
                        <span className="">
                          {this._measureInfo.bssid_info &&
                          this._measureInfo.bssid_info.ap_custom_data ? (
                            <strong>
                              <span className="mr-2 ">
                                ({this._measureInfo.bssid})
                              </span>
                            </strong>
                          ) : (
                            ""
                          )}
                          {/* {this._measureInfo.last_freq
                        ? this.getAppContext().freqToLabel(this._measureInfo.last_freq)
                        : null} */}
                        </span>
                      </span>
                    )}
                  </span>
                ) : (
                  "-"
                )}
                <small className="text-left d-flex align-items-center mt-3">
                  <div className="flex-shrink-1 mr-2 pr-2 border-right border-gray300">
                    <strong className="sub-title">FROM:</strong>
                    <strong className="pl-2">
                      <span>
                        {this.getAppContext()
                          .momentjs(sTimeView, "X")
                          .format("L LT")}
                      </span>
                    </strong>
                  </div>
                  <div className="flex-shrink-1 mr-2 pr-2 border-right border-gray300">
                    <strong className="sub-title">TO:</strong>
                    <strong className="pl-2">
                      <span>
                        {this.getAppContext()
                          .momentjs(eTimeView, "X")
                          .format("L LT")}
                      </span>
                    </strong>
                  </div>
                  <div className="flex-shrink-1 mr-2 border-right border-gray300">
                    <strong className="sub-title">Y scale:</strong>
                    <strong className="pl-2">
                      <span>
                        <Input
                          className="form-control input-header-modal"
                          bsSize="xs"
                          value={this.handleValueModal()}
                          type="text"
                          placeholder="Seconds"
                          invalid={this.state.invalidYref}
                          disabled={this.state.loadingStepTiming}
                          onChange={(e) => {
                            let string = e.target.value;
                            this.setState({
                              inputFieldValueModal: string,
                              startSpin: true,
                            });

                            if (!this.state.switchError) {
                              if (
                                /^\d+(\.\d+|\,\d+){0,1}$/.test(string) ||
                                string == "" ||
                                string == "MAX" ||
                                string == "AVG2"
                              ) {
                                this.setState({ invalidYref: false });
                                // delay
                                this.globalTime = Date.now();
                                let singleTime = Date.now();
                                setTimeout(() => {
                                  this.delay(singleTime, string);
                                }, 800);
                              } else {
                                this.setState({ invalidYref: true });
                              }
                            } else {
                              if (
                                /^\d+(\.\d+|\,\d+){0,1}$/.test(string) ||
                                string == "" ||
                                string == "MAX"
                              ) {
                                this.setState({ invalidYref: false });
                                // delay
                                this.globalTime = Date.now();
                                let singleTime = Date.now();
                                setTimeout(() => {
                                  this.delay(singleTime, string);
                                }, 800);
                              } else {
                                this.setState({ invalidYref: true });
                              }
                            }
                          }}
                        />
                        {this.state.startSpin &&
                        this.state.invalidYref == false ? (
                          <span className="valid-spin">
                            <ClipLoader
                              color={this.getAppContext().colors.primary}
                              size={15}
                              margin="5px"
                            />
                          </span>
                        ) : null}
                      </span>
                    </strong>
                    <span>
                      <span
                        id="yref_tooltip_m"
                        className="sub-title icon-info ml-2 mr-2 align-middle"
                        // style={{ fontSize: "130%" }}
                      />
                      <ReactOTooltip
                        placement="right"
                        target="yref_tooltip_m"
                        text={
                          <div className="text-left">
                            {!this.state.switchError ? (
                              <>
                                <span className="mb-1">Type:</span>
                                <br />
                                - a number <br />
                                - MAX: set Ymax to the highest measure
                                <br />
                                - AVG2: set Ymax to twice TOTAL AVG TIME
                                <br />
                              </>
                            ) : (
                              <>
                                <span className="mb-1">Type:</span>
                                <br />
                                - a number <br />- MAX: highest error count
                              </>
                            )}
                          </div>
                        }
                      />
                    </span>
                  </div>
                  {this.getAppContext().isCloud() && (
                    <div>
                      <ReactOButton
                        icon="download"
                        size="sm"
                        color="secondary"
                        outline
                        disabled={
                          (this.state.loading && !this._IS_AUTO_RELOADING) ||
                          this.state.loading_csv
                        }
                        onClick={() => {
                          let bssid =
                            this.props.match.params.bssid == "overal"
                              ? "ffffffffffff"
                              : this.props.match.params.bssid;
                          let csv =
                            this.props.match.params.measureid +
                            "@" +
                            bssid +
                            "@" +
                            this.state.measure_graph.test +
                            "_" +
                            this.state.measure_graph.viewRangeData.etime +
                            "_" +
                            this.state.measure_graph.viewRangeData.stime +
                            "_" +
                            this.props.match.params.probeuid +
                            ".csv";

                          this.downloadCsv(bssid, csv);
                        }}
                      >
                        CSV
                        <ReactOTooltip
                          placement="right"
                          target="csv_tooltip_m"
                          text={
                            this.state.measure_graph &&
                            this.state.measure_graph.graphData &&
                            this.state.measure_graph.graphData.measures_count &&
                            this.state.measure_graph.graphData.measures_count >
                              0
                              ? this.getAppContext().conf.CSV_data
                              : this.getAppContext().conf.CSV_no_data
                          }
                        />
                      </ReactOButton>
                      <span
                        id="csv_tooltip_m"
                        className="sub-title mt-1 icon-info ml-2 mr-2 align-middle"
                        // style={{ fontSize: "120%" }}
                      />
                    </div>
                  )}
                  {data.graphData.errors_count > 0 && (
                    <div className="ml-auto">
                      <div className="d-flex">
                        <CustomInput
                          value={this.state.switchError ? "errors" : "times"}
                          bsSize="sm"
                          disabled={
                            !this.state.errorPerHour ||
                            data.graphData.errors_count == 0
                          }
                          onChange={(e) => {
                            const { value } = e.target;
                            this.handleSwitchError(value);
                          }}
                          type="select"
                          name="Errors graphs"
                          id="errorsstep"
                        >
                          <option value="times">Times</option>
                          <option value="errors">Errors</option>
                        </CustomInput>
                      </div>
                    </div>
                  )}
                </small>
              </div>
            );
          }}
          body={(data) => {
            // console.log("data state", this.state.step_graph);
            return (
              <div>
                {this.state.step_graph != null && (
                  <div>
                    <ReactOTable
                      tdClassName="td-stepTiming justify-content-start"
                      thClassName="th-stepTiming"
                      size="lg"
                      cols={[
                        {
                          title: "STEP",
                          data_key: "step",
                          align: "center",
                          width: "10",
                        },
                        {
                          title: "CHART",
                          data_key: "graph",
                          align: "center",
                          width: "75",
                        },
                      ]}
                      compressed={
                        this.getAppContext().media.isMobile ||
                        this.getAppContext().media.isTablet
                      }
                      thDividers
                      rows={(() => {
                        let _TMP_LIST = [];
                        Object.keys(this.state.step_graph).forEach(
                          (step, id) => {
                            _TMP_LIST.push({
                              className:
                                this.state.measure_graph.essid != "Ethernet" &&
                                step == "rssi"
                                  ? "border-top border-2 border-gray400"
                                  : "",
                              step: {
                                value: step,
                                render: (
                                  <div
                                    id={"_tp_" + step + "_modal_" + id}
                                    className="d-flex"
                                    style={
                                      step == "rssi" ||
                                      step == "overlap" ||
                                      data.graphData.phases_timing[step] != null
                                        ? {
                                            cursor: "pointer",
                                            paddingLeft: "1em",
                                          }
                                        : { paddingLeft: "1em" }
                                    }
                                    onClick={(e) => {
                                      if (
                                        step == "rssi" ||
                                        step == "overlap" ||
                                        (data.graphData.phases_timing[step] &&
                                          data.graphData.phases_timing[step] !=
                                            null)
                                      ) {
                                        e.preventDefault();

                                        if (this.state.switchError) {
                                          if (
                                            this.state.step_graph[step] == null
                                          ) {
                                            this.loadSteptiming(step, true);
                                          } else {
                                            this.setState((prev_state) => {
                                              prev_state.step_graph[
                                                step
                                              ].display =
                                                !prev_state.step_graph[step]
                                                  .display;
                                              return prev_state;
                                            });
                                          }
                                        } else {
                                          if (
                                            this.state.step_graph[step] == null
                                          ) {
                                            this.loadSteptiming(step);
                                          } else {
                                            this.setState((prev_state) => {
                                              prev_state.step_graph[
                                                step
                                              ].display =
                                                !prev_state.step_graph[step]
                                                  .display;
                                              return prev_state;
                                            });
                                          }
                                        }
                                      }
                                    }}
                                  >
                                    <div
                                      className="mr-2"
                                      style={{
                                        backgroundColor:
                                          this.state.step_graph[step] != null &&
                                          this.state.step_graph[step].display ==
                                            true
                                            ? this.state.switchError
                                              ? data.graphData.phases_colors
                                                  .errors[step]
                                              : data.graphData.phases_colors
                                                  .measures[step]
                                            : null,
                                        width:
                                          (step == "rssi" &&
                                            this.state.step_graph["rssi"] &&
                                            this.state.step_graph["rssi"]
                                              .display &&
                                            this.state.step_graph["rssi"]
                                              .display == true) ||
                                          (step == "overlap" &&
                                            this.state.step_graph["overlap"] &&
                                            this.state.step_graph["overlap"]
                                              .display &&
                                            this.state.step_graph["overlap"]
                                              .display == true)
                                            ? "0"
                                            : "30px",
                                        height:
                                          this.state.step_graph[step] != null &&
                                          this.state.step_graph[step].display ==
                                            true
                                            ? "30px"
                                            : null,
                                      }}
                                    />

                                    {step == "rssi" &&
                                      this.state.step_graph["rssi"] &&
                                      this.state.step_graph["rssi"].display &&
                                      this.state.step_graph["rssi"].display ==
                                        true && (
                                        <div>
                                          <div
                                            style={{
                                              float: "left",
                                              width: "7px",
                                              height: "10px",
                                              border: "1px solid #de514e",
                                              borderWidth: "0 1px 1px 0",
                                            }}
                                          ></div>
                                          <div
                                            style={{
                                              float: "left",
                                              width: "7px",
                                              height: "21px",
                                              border: "1px solid #de514e",
                                              borderWidth: "1px 1px 0 0",
                                            }}
                                          ></div>
                                          <div
                                            style={{
                                              float: "left",
                                              marginRight: "7px",
                                              width: "7px",
                                              height: "10px",
                                              marginTop: "11px",
                                              border: "1px solid #de514e",
                                              borderWidth: "0 1px 1px 0",
                                            }}
                                          ></div>
                                        </div>
                                      )}
                                    {step == "overlap" &&
                                      this.state.step_graph["overlap"] &&
                                      this.state.step_graph["overlap"]
                                        .display &&
                                      this.state.step_graph["overlap"]
                                        .display == true && (
                                        <div>
                                          <div
                                            style={{
                                              float: "left",
                                              width: "7px",
                                              height: "10px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "0 1px 1px 0",
                                            }}
                                          ></div>
                                          <div
                                            style={{
                                              float: "left",
                                              width: "7px",
                                              height: "21px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "1px 1px 0 0",
                                            }}
                                          ></div>
                                          <div
                                            style={{
                                              float: "left",
                                              marginRight: "6px",
                                              width: "7px",
                                              height: "10px",
                                              marginTop: "11px",
                                              border: "1px solid #FFA559",
                                              borderWidth: "0 1px 1px 0",
                                            }}
                                          ></div>
                                        </div>
                                      )}
                                    <div className={"align-self-center"}>
                                      <span
                                        // className={
                                        //   data.graphData.phases_timing[step] &&
                                        //   data.graphData.phases_timing[step] == null
                                        //     ? "text-gray500"
                                        //     : ""
                                        // }
                                        className={
                                          step == "rssi" ||
                                          step == "overlap" ||
                                          data.graphData.phases_timing[step] !=
                                            null
                                            ? ""
                                            : "text-gray500"
                                        }
                                      >
                                        {" "}
                                        {(step == "rssi" && "RSSI dBm") ||
                                          (step == "overlap" &&
                                            "Overlap Index") ||
                                          step}{" "}
                                      </span>
                                    </div>
                                    <ReactOTooltip
                                      placement="bottom"
                                      delay={{ show: 200 }}
                                      target={"_tp_" + step + "_modal_" + id}
                                      text={
                                        step != "rssi" &&
                                        step != "overlap" &&
                                        data.graphData.phases_timing[step] ==
                                          null
                                          ? "Step not configured to run in this time interval"
                                          : this.state.step_graph[step] == null
                                            ? "Show step"
                                            : this.state.step_graph[step]
                                                  .display
                                              ? "Hide step"
                                              : "Show step"
                                      }
                                    />
                                  </div>
                                ),
                              },
                              graph: {
                                value: "graph",
                                render: (
                                  <div key={id}>
                                    {this.state.step_graph[step] != null &&
                                    !this.state.step_graph[step].msg &&
                                    this.state.step_graph[step].display ==
                                      true ? (
                                      <_LoadingWrapper
                                        loadingPlug={
                                          step == "rssi" || step == "overlap"
                                            ? false
                                            : this.state.loadingIMG
                                        }
                                      >
                                        {this.state.switchError ? (
                                          <ErrorTimingGraph
                                            data={data}
                                            step={step}
                                            idx={id}
                                            switchError={this.state.switchError}
                                            loadStepBatch={this.loadStepBatch.bind(
                                              this,
                                            )}
                                            stopLoadingIMG={this.stopLoadingIMG.bind(
                                              this,
                                            )}
                                            setErrorViewRange={this.setErrorViewRange.bind(
                                              this,
                                            )}
                                            stepGraph={this.state.step_graph}
                                            _errors_index_modal={
                                              this._errors_index_modal
                                            }
                                            loadErrorGraph={this.loadErrorGraph.bind(
                                              this,
                                            )}
                                            errorViewRange={
                                              this.state.errorViewRange
                                            }
                                            phaseColors={
                                              this.phaseColors.errors
                                            }
                                            _notes_editing_ctrl={
                                              this._notes_editing_ctrl
                                            }
                                            notes={
                                              this.state.measure_graph.notes
                                            }
                                            range={this.state.range}
                                            errorPerHour={
                                              this.state.errorPerHour
                                            }
                                            unit={
                                              (step == "rssi" && "-dBm") ||
                                              (step == "overlap" && " ") ||
                                              "errors / hours"
                                            }
                                          />
                                        ) : (
                                          <StepTimingGraph
                                            data={data}
                                            step={step}
                                            idx={id}
                                            loadStepBatch={this.loadStepBatch.bind(
                                              this,
                                            )}
                                            stopLoadingIMG={this.stopLoadingIMG.bind(
                                              this,
                                            )}
                                            stepGraph={this.state.step_graph}
                                            phaseColors={
                                              this.phaseColors.measures
                                            }
                                            _notes_editing_ctrl={
                                              this._notes_editing_ctrl
                                            }
                                            notes={
                                              this.state.measure_graph.notes
                                            }
                                            range={this.state.range}
                                            unit={
                                              (step == "rssi" && "-dBm") ||
                                              (step == "overlap" && " ") ||
                                              "seconds"
                                            }
                                          />
                                        )}
                                      </_LoadingWrapper>
                                    ) : this.state.step_graph &&
                                      this.state.step_graph[step] &&
                                      this.state.step_graph[step].msg &&
                                      this.state.step_graph[step].display ? (
                                      <div className="py-2">
                                        {this.state.step_graph[step].msg}
                                      </div>
                                    ) : null}
                                  </div>
                                ),
                              },
                            });
                          },
                        );
                        return _TMP_LIST;
                      })()}
                    />
                  </div>
                )}
              </div>
            );
          }}
        />

        {/* ERROR chart */}
        <ReactOModal
          modalId="errorGraph"
          bodyClassName="stepTiming-body-modal"
          size="xl"
          // className="modal-timing"
          onControllerReady={(modal_context) => {
            this._errorGraph_modal = modal_context;
          }}
          onModalMounted={(data) => {
            // ERROR PROCESS
            const { graphData } = data;
            const start_time = parseInt(graphData.ImgStart);
            const end_time = parseInt(graphData.ImgEnd);
            const { errors_statistics } = graphData;

            let raw_errors = [];
            let arrayOfErrors = [];
            let objectOfErrors = {};

            if (graphData && graphData.errors_statistics.details) {
              Object.keys(errors_statistics.details).forEach((ts) => {
                Object.keys(errors_statistics.details[ts]).forEach((phase) =>
                  raw_errors.push(phase),
                );
                Object.keys(errors_statistics.details[ts]).forEach((phase) => {
                  if (!objectOfErrors[phase]) {
                    objectOfErrors[phase] = 0;
                  }
                });
              });
              arrayOfErrors = [...new Set(raw_errors)];
              this.setState({ arrayOfErrors: arrayOfErrors });
            }
            let hourNumber = [];

            for (let t = start_time + 3600; t <= end_time; t = t + 3600) {
              hourNumber.push(t);
            }

            let resulted = {};

            hourNumber.forEach((t, id, array) => {
              let errors = { ...objectOfErrors };
              // errors._tot = 0;
              Object.keys(objectOfErrors).forEach((phase) => {
                Object.keys(errors_statistics.details).forEach((ts) => {
                  if (ts <= t && ts >= t - 3600) {
                    if (errors_statistics.details[ts][phase]) {
                      let current = parseInt(errors[phase]);
                      let increment =
                        current +
                        parseInt(errors_statistics.details[ts][phase]);
                      errors[phase] = increment;
                    }
                  }
                });
              });
              // console.log("errors", errors);
              let total = 0;

              Object.values(errors).forEach((n) => {
                // console.log("n", n);
                total = total + n;
                // console.log("total", total);
              });

              resulted[t] = errors;
              resulted[t].tot = total;
            });

            let maxErrorPerHour = { ...objectOfErrors };
            maxErrorPerHour.maxValue = 0;

            Object.keys(objectOfErrors).forEach((phase) => {
              Object.keys(resulted).forEach((ts) => {
                if (resulted[ts][phase] > maxErrorPerHour[phase])
                  maxErrorPerHour[phase] = resulted[ts][phase];

                if (resulted[ts][phase] > maxErrorPerHour.maxValue) {
                  maxErrorPerHour.maxValue = resulted[ts][phase];
                }
              });
            });

            this.setState({
              maxErrorPerHour: maxErrorPerHour,
              errorPerHour: resulted,
              errorViewRange: {
                ...data.viewRangeData,
                stime: start_time,
                etime: end_time,
              },
              timingView: true,
              inputFieldValueModal:
                this.state.inputFieldValue || this.state.measure_graph.Yref,
              invalidYref: false,
              startSpin: false,
            });
          }}
          onModalUnmounted={(data) => {
            this.setState(
              {
                ErrorGraphValue: undefined,
                showErrorGraph: false,
                timingView: false,
                switchError: false,
                maxErrorPerHour: null,
                errorPerHour: null,
                errorViewRange: null,
                customYrefModal: undefined,
              },
              () => {
                this.getAppContext()
                  .getLocalStorageService()
                  .remove("measure_steplist_view");
              },
            );
          }}
          modalClassName="modal-stepTiming-header"
          header={(data) => {
            return (
              <div className="stepTiming-steptiming">
                Errors percentage chart
                <small className="text-left d-flex align-items-center">
                  <div className="flex-shrink-1 mr-2 pr-2 border-right border-gray300">
                    <strong className="sub-title">FROM:</strong>
                    <strong className="pl-2">
                      <span>
                        {this.getAppContext()
                          .momentjs(data.graphData.ImgStart, "X")
                          .format("L LT")}
                      </span>
                    </strong>
                  </div>
                  <div className="flex-shrink-1 mr-2 pr-2 border-right border-gray300">
                    <strong className="sub-title">TO:</strong>
                    <strong className="pl-2">
                      <span>
                        {this.getAppContext()
                          .momentjs(data.graphData.ImgEnd, "X")
                          .format("L LT")}
                      </span>
                    </strong>
                  </div>
                  <div className="flex-shrink-1 mr-2 border-right border-gray300">
                    <strong className="sub-title">Y scale (%):</strong>
                    <strong className="pl-2">
                      <span>
                        <Input
                          className="form-control input-header-modal"
                          bsSize="xs"
                          value={this.handleErrorGraphValueModal()}
                          type="text"
                          placeholder=""
                          invalid={this.state.invalidYref}
                          disabled={
                            this.state.loadingStepTiming ||
                            this.state.switchError
                          }
                          onChange={(e) => {
                            let string = e.target.value;
                            this.setState({
                              ErrorGraphValue: string,
                              startSpin: true,
                            });
                            if (
                              /^\d+(\.\d+|\,\d+){0,1}$/.test(string) &&
                              parseInt(string) <= 100
                            ) {
                              this.setState({
                                invalidYref: false,
                                showErrorGraph: true,
                              });
                              // delay
                              this.globalTime = Date.now();
                              let singleTime = Date.now();
                              setTimeout(() => {
                                this.delay(
                                  singleTime,
                                  string.replace(/,/g, "."),
                                );
                              }, 800);
                            } else {
                              this.setState({ invalidYref: true });
                            }
                          }}
                        />
                        {this.state.startSpin &&
                        this.state.invalidYref == false ? (
                          <span className="valid-spin">
                            <ClipLoader
                              color={this.getAppContext().colors.primary}
                              size={15}
                              margin="5px"
                            />
                          </span>
                        ) : null}
                      </span>
                    </strong>
                    <span>
                      <span
                        id="yref_tooltip_m"
                        className="sub-title icon-info ml-2 mr-2 align-middle"
                        // style={{ fontSize: "130%" }}
                      />
                      <ReactOTooltip
                        placement="right"
                        target="yref_tooltip_m"
                        text={
                          <div className="text-left">
                            <span className="mb-1">{`Type a number <= 100`}</span>
                            {/* <br />
                            - a number <br />
                            - MAX: set Ymax to the highest measure
                            <br />
                            - AVG2: set Ymax to twice TOTAL AVG TIME
                            <br /> */}
                          </div>
                        }
                      />
                    </span>
                  </div>
                  <div className="ml-auto">
                    <div className="d-flex">
                      <small
                        style={{ cursor: "pointer" }}
                        className="text-primary"
                      >
                        <div
                          onClick={() => {
                            let stepToCall = this.state.arrayOfErrors[0];
                            this.setState(
                              {
                                switchError: true,
                                customYrefModal: undefined,
                                timingView: false,
                                inputFieldValueModal:
                                  this.state.maxErrorPerHour.maxValue + 1,
                              },
                              () => {
                                if (!this.state.loadingStepTiming) {
                                  let storedViewrange = {
                                    ...this.getAppContext()
                                      .getLocalStorageService()
                                      .get("measure_graph_view"),
                                  };

                                  if (storedViewrange.is_preset == "yes") {
                                    let sourceViewrange = {
                                      ...this.state.measure_graph.viewRangeData,
                                    };
                                    sourceViewrange.is_preset = "no";
                                    sourceViewrange.view_preset = "no";
                                    if (sourceViewrange.offset) {
                                      delete sourceViewrange.offset;
                                    }
                                    this.getAppContext()
                                      .getLocalStorageService()
                                      .set(
                                        "measure_steplist_view",
                                        sourceViewrange,
                                      );
                                    this.loadSteptiming(stepToCall, true);
                                  } else if (
                                    storedViewrange.is_preset == "no"
                                  ) {
                                    this.getAppContext()
                                      .getLocalStorageService()
                                      .set(
                                        "measure_steplist_view",
                                        storedViewrange,
                                      );
                                    this.loadSteptiming(stepToCall, true);
                                  }
                                }
                              },
                            );
                          }}
                        >
                          Split view on errors
                        </div>
                      </small>
                    </div>
                  </div>
                </small>
              </div>
            );
          }}
          body={(data) => {
            return (
              <div>
                <_LoadingWrapper loadingPlug={this.state.loadingErrorGraph}>
                  {this.state.errorGraph != null && (
                    <div>
                      <ErrorGraph
                        data={data}
                        stime={parseInt(data.graphData.ImgStart)}
                        etime={parseInt(data.graphData.ImgEnd)}
                        loadErrorGraph={this.loadErrorGraph.bind(this)}
                        phaseColors={this.phaseColors.errors}
                        _errors_index_modal={this._errors_index_modal}
                        _errorGraph_modal={this._errorGraph_modal}
                        unit="%"
                      />
                    </div>
                  )}
                </_LoadingWrapper>
              </div>
            );
          }}
        />

        {/* ERROR INDEX */}
        <ReactOModal
          modalId="overlap"
          size="lg"
          onControllerReady={(modal_context) => {
            this._errors_index_modal = modal_context;
          }}
          onModalMounted={(data) => {
            this.getAppContext()
              .getLocalStorageService()
              .set("errors_index_opened", data);
          }}
          onModalUnmounted={(data) => {
            this.getAppContext()
              .getLocalStorageService()
              .remove("errors_index_opened");
          }}
          header={(data) => {
            return (
              <div>
                Errors index
                <small className="text-left d-flex align-items-center">
                  <div className="flex-shrink-1 mr-2 pr-2 border-right border-gray300">
                    <strong className="sub-title">FROM:</strong>
                    <strong className="pl-2">
                      <span>
                        {this.getAppContext()
                          .momentjs(data.stime, "X")
                          .format("L LT")}
                      </span>
                    </strong>
                  </div>
                  <div className="flex-shrink-1 mr-2">
                    <strong className="sub-title">TO:</strong>
                    <strong className="pl-2">
                      <span>
                        {this._errorGraph_modal.isOpen() ||
                        this._stepTiming_modal.isOpen()
                          ? this.getAppContext()
                              .momentjs(data.etime + 60, "X")
                              .format("L LT")
                          : this.getAppContext()
                              .momentjs(data.etime, "X")
                              .format("L LT")}
                      </span>
                    </strong>
                  </div>
                </small>
              </div>
            );
          }}
          bodyClassName="p-0"
          body={(data) => {
            return data.errors_statistics ? (
              <div>
                <Row noGutters>
                  <Col xs={12} sm={3}>
                    <div className="measure-result-list border-2 border-right border-gray300 h-100">
                      <ListGroup flush>
                        {data.phases_sequence.map((_CURR_phase, _CURR_idx) => {
                          return data.errors_statistics[_CURR_phase] ? (
                            <ListGroupItem
                              key={_CURR_idx}
                              tag="a"
                              href="#"
                              action
                              className={"d-flex result-item py-3"}
                              active={data.selected == _CURR_phase}
                              onClick={() => {
                                data.selected = _CURR_phase;
                                this.forceUpdate();
                              }}
                            >
                              <div
                                className={
                                  "flex-grow-1 mr-1 text-nowrap" +
                                  (this.getAppContext().media.isMobile ||
                                  this.getAppContext().media.isTablet
                                    ? "text-center"
                                    : "")
                                }
                              >
                                <strong>
                                  {_CURR_phase == "DISCEARLY"
                                    ? "Early drop"
                                    : _CURR_phase}
                                  <span className="ml-1">
                                    {" "}
                                    {"(" +
                                      (
                                        (data.errors_statistics[_CURR_phase]
                                          .total /
                                          data.total) *
                                        100
                                      ).toFixed(1) +
                                      "%)"}
                                  </span>
                                </strong>
                              </div>

                              {!this.getAppContext().media.isMobile &&
                              !this.getAppContext().media.isTablet &&
                              data.selected == _CURR_phase ? (
                                <span className="icon-play ml-2 align-self-center" />
                              ) : null}
                            </ListGroupItem>
                          ) : null;
                        })}
                      </ListGroup>
                    </div>
                  </Col>
                  <Col className="bg-light pb-3 rounded-right rounded-top-0">
                    <Section
                      className="border-bottom border-gray300"
                      layoutManager="grid"
                      elementsPerRow={3}
                      gridSpacing={1}
                      gridSpacingColor={this.getAppContext().colors.gray300}
                    >
                      <div className="d-flex flex-column p-3">
                        <div className="sub-title mb-2">
                          <strong>TOTAL ERRORS</strong>
                        </div>
                        <h4 className="d-flex h-100 align-items-start text-danger">
                          {data.errors_statistics[data.selected].total}
                        </h4>
                      </div>

                      <div className="d-flex flex-column p-3">
                        <div className="sub-title mb-2">
                          <strong>% ON MEASURES COUNT</strong>
                        </div>
                        <h4 className="d-flex h-100 align-items-start">
                          {"" +
                            (
                              (data.errors_statistics[data.selected].total /
                                data.total) *
                              100
                            ).toFixed(1) +
                            "%"}
                        </h4>
                      </div>

                      <div className="d-flex flex-column p-3">
                        <div className="sub-title mb-2">
                          <strong>% ON ERRORS COUNT</strong>
                        </div>
                        <h4 className="d-flex h-100 align-items-start">
                          {(
                            (data.errors_statistics[data.selected].total /
                              data.total_errors) *
                            100
                          ).toFixed(1)}{" "}
                          %
                        </h4>
                      </div>
                    </Section>
                    <div className="overflow-auto">
                      <ReactOTable
                        thClassName="px-3 py-1"
                        tdClassName="align-middle px-3 py-2"
                        hoverable
                        compressed={
                          this.getAppContext().media.isMobile ||
                          this.getAppContext().media.isTablet
                        }
                        compressedRowRendering={(row_items) => {
                          return (
                            <div>
                              <Row className="mt-2">
                                <Col>
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>{row_items.ts.title}</strong>
                                    </small>
                                  </div>
                                  {row_items.ts.content}
                                </Col>
                                <Col>
                                  <div className="text-muted">
                                    <small className="">
                                      <strong>
                                        {row_items.errors_count.title}
                                      </strong>
                                    </small>
                                  </div>
                                  {row_items.errors_count.content}
                                </Col>
                              </Row>
                            </div>
                          );
                        }}
                        thDividers
                        //	onTableLeave={() => {
                        //		this._pie_chart.unsetActive()
                        //	}}
                        onRowClick={(row_data) => {
                          this.getAppContext().redirectTo(
                            "/" +
                              this.props.match.params.probeuid +
                              "/" +
                              this.props.match.params.status +
                              "/" +
                              this.props.match.params.measureid +
                              "/" +
                              this.props.match.params.bssid +
                              "/results/" +
                              row_data.ts.value +
                              "/" +
                              data.selected,
                          );
                        }}
                        defaultSort={[
                          {
                            data_key: "ts",
                            order: "asc",
                          },
                        ]}
                        cols={[
                          {
                            title: "DATETIME",
                            data_key: "ts",
                            width: "50",
                            sortable: true,
                          },
                          {
                            title: "ERRORS COUNT",
                            data_key: "errors_count",
                            width: "50",
                            sortable: true,
                          },
                        ]}
                        rows={(() => {
                          let _TMP = [];
                          (
                            data.errors_statistics[data.selected].list || []
                          ).forEach((_C_error_ts_data, _C_idx) => {
                            _TMP.push({
                              index: _C_idx,
                              ts: {
                                value: _C_error_ts_data.ts - 60,
                                render: (
                                  <span>
                                    {this.getAppContext()
                                      .momentjs(_C_error_ts_data.ts - 60, "X")
                                      .format("L LT")}
                                  </span>
                                ),
                              },
                              errors_count: {
                                value: _C_error_ts_data.errors_count,
                                render: (
                                  <span>
                                    <strong>
                                      {_C_error_ts_data.errors_count}
                                    </strong>
                                  </span>
                                ),
                              },
                            });
                          });
                          return _TMP;
                        })()}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            ) : null;
          }}
        />
        <NotesEditor
          probeuid={this.props.match.params.probeuid}
          measureid={this.props.match.params.measureid}
          notes={this.state.measure_graph.notes}
          onNewNotesAvailable={(new_notes, cb) => {
            this.setState((prev_state) => {
              prev_state.measure_graph.notes = new_notes;
              this.fillFrequencySwitchNotes(
                prev_state.measure_graph.notes,
                prev_state.measure_graph.graphData.freq_changes,
              );
              prev_state.loading_notes = false;
              return prev_state;
            }, cb);
          }}
          onGoToNote={(ts) => {
            this._view_form.handleFormChange("is_preset", "no");
            this._view_form.handleFormChange("view_preset", "no");
            this._view_form.handleFormChange("offset", false);
            this._view_form.handleFormChange("stime", ts - 7200);
            this._view_form.handleFormChange("etime", ts + 7200);
            this._view_form.submit();
          }}
          onLoadingStarted={(cb) => {
            this.setState({ loading_notes: true }, cb);
          }}
          onLoadingStopped={(cb) => {
            this.setState({ loading_notes: false }, cb);
          }}
          onReady={(notes_editing_ctrl) => {
            this._notes_editing_ctrl = notes_editing_ctrl;
          }}
        />
      </Section>
    );
  }
}

export default contextProvider(ProbeMeasureExplorer, {
  define: null,
});
